// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import "./components/reboot";
@import "./components/grid";
@import "./components/type";
@import "./components/buttons";
@import "./components/forms";
@import "./components/input-group";
@import "./components/text";
@import "./components/custom-forms"; */
.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

* {
  box-sizing: border-box;
}

.material-icons {
  box-sizing: content-box;
  box-sizing: initial;
}

html {
  font-size: 14px;
}

body {
  margin: 0;
  padding: 0;
  font-family: Inter, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.sidebar-icon-gap {
  padding-left: 38px !important;
}

.ff-1 {
  font-family: "Poppins", sans-serif !important;
}

.ff-2 {
  font-family: "PT Sans", sans-serif !important;
}

.ff-3 {
  font-family: "Raleway", sans-serif !important;
}

.ff-4 {
  font-family: "Roboto", sans-serif !important;
}

.ff-5 {
  font-family: "Nunito", sans-serif !important;
}

.hover {
  cursor: pointer;
}

.reminder-cost small {
  font-style: italic;
  font-size: 12px;
  font-weight: normal;
}

.mainten-section {
  padding: 10px;
  margin-bottom: 10px;
  font-size: 12px;
}
.mainten-section .text-overdue {
  color: #d32f2f;
}
.mainten-section .text-scheduled {
  color: #1879EB;
}
.mainten-section .text-due {
  color: #F69B24;
}
.mainten-section .toggle-section-button {
  margin-left: 10px;
  vertical-align: middle;
}
.mainten-section .mainten-column-section {
  display: flex;
  padding-bottom: 6px;
  margin-bottom: 6px;
}
.mainten-section .mainten-column-section > div {
  flex: 1 1;
}
.mainten-section .mainten-section-header {
  display: flex;
  justify-content: space-between;
  border-bottom-width: 2px;
  border-bottom-style: dashed;
  padding-bottom: 6px;
  margin-bottom: 6px;
}
.mainten-section .mainten-highlight-section,
.mainten-section .mainten-split-section {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: center;
}
.mainten-section .mainten-highlight-section > div:first-child,
.mainten-section .mainten-split-section > div:first-child {
  border-right-width: 2px;
  border-right-style: dashed;
  padding-right: 20px;
}
.mainten-section .mainten-highlight-section > div,
.mainten-section .mainten-split-section > div {
  flex: 1 1;
}
.mainten-section .mainten-highlight-section {
  padding: 10px;
}
.mainten-section .mainten-highlight-section > div {
  text-align: center;
}
.mainten-section .mainten-section-footer {
  border-top-width: 2px;
  border-top-style: dashed;
  display: flex;
  gap: 6px;
  padding-top: 10px;
  justify-content: flex-end;
  text-align: right;
}
.mainten-section .mainten-section-footer .theme-button {
  margin-bottom: 6px;
}
.mainten-section .mainten-section-footer .theme-button ~ .theme-button {
  margin-left: 6px;
}

.reminder-section {
  border: 2px dashed;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 12px;
}
.reminder-section label {
  display: block;
}
.reminder-section .reminder-section-header {
  display: flex;
  justify-content: space-between;
  border-bottom-width: 2px;
  border-bottom-style: dashed;
  padding-bottom: 6px;
  margin-bottom: 6px;
  align-items: center;
}
.reminder-section .reminder-section-footer {
  display: flex;
  gap: 6px;
  justify-content: flex-end;
  text-align: right;
}
.reminder-section .reminder-section-footer .theme-button {
  margin-bottom: 6px;
}
.reminder-section .reminder-section-footer .theme-button ~ .theme-button {
  margin-left: 6px;
}
.reminder-section .reminder-section-body {
  display: flex;
  gap: 20px;
  margin-bottom: 12px;
}

.leaflet-container {
  font-family: inherit;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

a {
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}

.list-unstyled {
  list-style: none;
}

.badge {
  display: inline-block;
  width: 1.2em;
  height: 1.2em;
  line-height: 1.2em;
  color: #fff;
  font-size: 12px;
  background: #666;
  text-align: center;
  border-radius: 50%;
}

.text-theme {
  color: #00c179;
}

.clearfix:before, .clearfix:after {
  display: table;
  content: " ";
  clear: both;
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.text-normal {
  font-size: 12px;
}

.v-hidden {
  visibility: hidden;
}

.form-check-label label,
.form-check-label {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  margin: 0;
}

.checkbox {
  -webkit-user-select: none;
  user-select: none;
  margin: 0;
}
.checkbox input {
  display: none;
}
.form-check-inline .checkbox input + span {
  margin-right: 5px;
}
.checkbox input + span {
  vertical-align: top;
  font-size: 14px;
  display: flex;
}
.checkbox input + span span {
  height: auto;
  line-height: inherit;
}
.checkbox input + span .on-active {
  display: none;
}
.checkbox input:checked + span .on-active {
  display: inline-block;
}
.checkbox input:checked + span .on-active svg {
  display: block;
}
.checkbox input:checked + span .on-inactive {
  display: none;
}

.has-menu {
  position: relative;
}
.has-menu .has-menu > a:after {
  content: "keyboard_arrow_right";
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  font-family: "Material Icons";
  font-size: 20px;
}

.horizontal-menu ul {
  white-space: nowrap;
}

.horizontal-menu li {
  display: inline-block;
  height: auto;
}

.sub-menu {
  position: absolute;
  top: 100%;
  background: #fff;
  border-top: 3px solid transparent;
  margin: 0;
  margin-top: -3px;
  padding: 0;
  list-style: none;
  min-width: 180px;
  left: 0;
  display: none;
  text-align: left;
  line-height: 1.4;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  z-index: 9;
}
.sub-menu li a {
  font-size: 12px;
  color: #333;
  text-decoration: none;
  display: block;
}
.sub-menu li a:hover .rel-icons {
  color: inherit;
}
.sub-menu label span,
.sub-menu a span {
  vertical-align: middle;
  display: inline-block;
}
.sub-menu .unit-name {
  min-width: inherit;
  line-height: inherit;
  margin-left: 0;
}
.sub-menu.right-menu {
  left: auto;
  right: 0;
}
.sub-menu.level-right {
  top: 0;
  left: 100%;
}
.sub-menu.level-left {
  top: 0;
  right: 100%;
  left: auto;
}
.sub-menu.left-top {
  bottom: 100%;
  top: auto;
}
.sub-menu.right-top {
  bottom: 100%;
  top: auto;
  right: 0;
  left: auto;
}
.sub-menu a {
  padding: 6px 9px;
}
.sub-menu label {
  display: block;
  margin: 0;
}
.sub-menu label input {
  vertical-align: middle;
  margin-right: 5px;
}
.sub-menu .rel-icons {
  margin-right: 5px;
  color: #aaa;
}

:hover > .sub-menu {
  display: block;
}

.divider {
  border-top: 1px solid rgb(178.5, 178.5, 178.5);
}

.sub-menu label:hover,
.sub-menu .active a,
.sub-menu a:hover {
  background: #fff;
  color: #00c179;
}

.center-menu {
  left: 50%;
  width: 340px;
  margin-left: -170px;
}

.marker {
  transition: transform 0.4s linear;
}

.leaflet-tooltip.has-animation {
  transition: transform 0.4s linear;
}
.leaflet-tooltip.has-animation img {
  transition: all 0.4s linear;
}

.color-inherit {
  color: inherit !important;
}

.geoList {
  list-style: none;
  margin: 6px 0 0;
  padding: 0;
}
.geoList .list-row {
  margin-bottom: 6px;
  border-radius: 5px;
  padding-left: 6px;
  box-sizing: border-box;
}
.geoList .list-row-1 {
  margin-bottom: 6px;
  border-radius: 5px;
  padding-left: 6px;
  width: 99%;
  box-sizing: border-box;
}

.geofences-columns-wise .geoList {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  /* .list-row-1 {
     width: 49%;
  } */
}

/* .custom-tabs .Mui-disabled {
  display: none;
}
 */
.seconds_1 {
  transition: transform 1s linear;
}
.seconds_1 img {
  transition: all 1s linear;
}

.seconds_2 {
  transition: transform 2s linear;
}
.seconds_2 img {
  transition: all 2s linear;
}

.seconds_3 {
  transition: transform 3s linear;
}
.seconds_3 img {
  transition: all 3s linear;
}

.seconds_4 {
  transition: transform 4s linear;
}
.seconds_4 img {
  transition: all 4s linear;
}

.seconds_5 {
  transition: transform 5s linear;
}
.seconds_5 img {
  transition: all 5s linear;
}

.seconds_6 {
  transition: transform 6s linear;
}
.seconds_6 img {
  transition: all 6s linear;
}

.seconds_7 {
  transition: transform 7s linear;
}
.seconds_7 img {
  transition: all 7s linear;
}

.seconds_8 {
  transition: transform 8s linear;
}
.seconds_8 img {
  transition: all 8s linear;
}

.seconds_9 {
  transition: transform 9s linear;
}
.seconds_9 img {
  transition: all 9s linear;
}

.seconds_10 {
  transition: transform 10s linear;
}
.seconds_10 img {
  transition: all 10s linear;
}

.seconds_11 {
  transition: transform 11s linear;
}
.seconds_11 img {
  transition: all 11s linear;
}

.seconds_12 {
  transition: transform 12s linear;
}
.seconds_12 img {
  transition: all 12s linear;
}

.seconds_13 {
  transition: transform 13s linear;
}
.seconds_13 img {
  transition: all 13s linear;
}

.seconds_14 {
  transition: transform 14s linear;
}
.seconds_14 img {
  transition: all 14s linear;
}

.seconds_15 {
  transition: transform 15s linear;
}
.seconds_15 img {
  transition: all 15s linear;
}

.seconds_16 {
  transition: transform 16s linear;
}
.seconds_16 img {
  transition: all 16s linear;
}

.seconds_17 {
  transition: transform 17s linear;
}
.seconds_17 img {
  transition: all 17s linear;
}

.seconds_18 {
  transition: transform 18s linear;
}
.seconds_18 img {
  transition: all 18s linear;
}

.seconds_19 {
  transition: transform 19s linear;
}
.seconds_19 img {
  transition: all 19s linear;
}

.seconds_20 {
  transition: transform 20s linear;
}
.seconds_20 img {
  transition: all 20s linear;
}

.seconds_21 {
  transition: transform 21s linear;
}
.seconds_21 img {
  transition: all 21s linear;
}

.seconds_22 {
  transition: transform 22s linear;
}
.seconds_22 img {
  transition: all 22s linear;
}

.seconds_23 {
  transition: transform 23s linear;
}
.seconds_23 img {
  transition: all 23s linear;
}

.seconds_24 {
  transition: transform 24s linear;
}
.seconds_24 img {
  transition: all 24s linear;
}

.seconds_25 {
  transition: transform 25s linear;
}
.seconds_25 img {
  transition: all 25s linear;
}

.seconds_26 {
  transition: transform 26s linear;
}
.seconds_26 img {
  transition: all 26s linear;
}

.seconds_27 {
  transition: transform 27s linear;
}
.seconds_27 img {
  transition: all 27s linear;
}

.seconds_28 {
  transition: transform 28s linear;
}
.seconds_28 img {
  transition: all 28s linear;
}

.seconds_29 {
  transition: transform 29s linear;
}
.seconds_29 img {
  transition: all 29s linear;
}

.seconds_30 {
  transition: transform 30s linear;
}
.seconds_30 img {
  transition: all 30s linear;
}

.seconds_31 {
  transition: transform 31s linear;
}
.seconds_31 img {
  transition: all 31s linear;
}

.seconds_32 {
  transition: transform 32s linear;
}
.seconds_32 img {
  transition: all 32s linear;
}

.seconds_33 {
  transition: transform 33s linear;
}
.seconds_33 img {
  transition: all 33s linear;
}

.seconds_34 {
  transition: transform 34s linear;
}
.seconds_34 img {
  transition: all 34s linear;
}

.seconds_35 {
  transition: transform 35s linear;
}
.seconds_35 img {
  transition: all 35s linear;
}

.seconds_36 {
  transition: transform 36s linear;
}
.seconds_36 img {
  transition: all 36s linear;
}

.seconds_37 {
  transition: transform 37s linear;
}
.seconds_37 img {
  transition: all 37s linear;
}

.seconds_38 {
  transition: transform 38s linear;
}
.seconds_38 img {
  transition: all 38s linear;
}

.seconds_39 {
  transition: transform 39s linear;
}
.seconds_39 img {
  transition: all 39s linear;
}

.seconds_40 {
  transition: transform 40s linear;
}
.seconds_40 img {
  transition: all 40s linear;
}

.seconds_41 {
  transition: transform 41s linear;
}
.seconds_41 img {
  transition: all 41s linear;
}

.seconds_42 {
  transition: transform 42s linear;
}
.seconds_42 img {
  transition: all 42s linear;
}

.seconds_43 {
  transition: transform 43s linear;
}
.seconds_43 img {
  transition: all 43s linear;
}

.seconds_44 {
  transition: transform 44s linear;
}
.seconds_44 img {
  transition: all 44s linear;
}

.seconds_45 {
  transition: transform 45s linear;
}
.seconds_45 img {
  transition: all 45s linear;
}

.seconds_46 {
  transition: transform 46s linear;
}
.seconds_46 img {
  transition: all 46s linear;
}

.seconds_47 {
  transition: transform 47s linear;
}
.seconds_47 img {
  transition: all 47s linear;
}

.seconds_48 {
  transition: transform 48s linear;
}
.seconds_48 img {
  transition: all 48s linear;
}

.seconds_49 {
  transition: transform 49s linear;
}
.seconds_49 img {
  transition: all 49s linear;
}

.seconds_50 {
  transition: transform 50s linear;
}
.seconds_50 img {
  transition: all 50s linear;
}

.seconds_51 {
  transition: transform 51s linear;
}
.seconds_51 img {
  transition: all 51s linear;
}

.seconds_52 {
  transition: transform 52s linear;
}
.seconds_52 img {
  transition: all 52s linear;
}

.seconds_53 {
  transition: transform 53s linear;
}
.seconds_53 img {
  transition: all 53s linear;
}

.seconds_54 {
  transition: transform 54s linear;
}
.seconds_54 img {
  transition: all 54s linear;
}

.seconds_55 {
  transition: transform 55s linear;
}
.seconds_55 img {
  transition: all 55s linear;
}

.seconds_56 {
  transition: transform 56s linear;
}
.seconds_56 img {
  transition: all 56s linear;
}

.seconds_57 {
  transition: transform 57s linear;
}
.seconds_57 img {
  transition: all 57s linear;
}

.seconds_58 {
  transition: transform 58s linear;
}
.seconds_58 img {
  transition: all 58s linear;
}

.seconds_59 {
  transition: transform 59s linear;
}
.seconds_59 img {
  transition: all 59s linear;
}

.seconds_60 {
  transition: transform 60s linear;
}
.seconds_60 img {
  transition: all 60s linear;
}

.scroll-width-0 .notification-page-wrapper {
  padding-top: 10px;
}
.scroll-width-0 .geofence-modal-form-inner {
  margin-right: 0px;
}
.scroll-width-0 .notification-scroller {
  margin-right: 0px;
}

.scroll-width-1 .notification-page-wrapper {
  padding-top: 11px;
}
.scroll-width-1 .geofence-modal-form-inner {
  margin-right: -1px;
}
.scroll-width-1 .notification-scroller {
  margin-right: -1px;
}

.scroll-width-2 .notification-page-wrapper {
  padding-top: 12px;
}
.scroll-width-2 .geofence-modal-form-inner {
  margin-right: -2px;
}
.scroll-width-2 .notification-scroller {
  margin-right: -2px;
}

.scroll-width-3 .notification-page-wrapper {
  padding-top: 13px;
}
.scroll-width-3 .geofence-modal-form-inner {
  margin-right: -3px;
}
.scroll-width-3 .notification-scroller {
  margin-right: -3px;
}

.scroll-width-4 .notification-page-wrapper {
  padding-top: 14px;
}
.scroll-width-4 .geofence-modal-form-inner {
  margin-right: -4px;
}
.scroll-width-4 .notification-scroller {
  margin-right: -4px;
}

.scroll-width-5 .notification-page-wrapper {
  padding-top: 15px;
}
.scroll-width-5 .geofence-modal-form-inner {
  margin-right: -5px;
}
.scroll-width-5 .notification-scroller {
  margin-right: -5px;
}

.scroll-width-6 .notification-page-wrapper {
  padding-top: 16px;
}
.scroll-width-6 .geofence-modal-form-inner {
  margin-right: -6px;
}
.scroll-width-6 .notification-scroller {
  margin-right: -6px;
}

.scroll-width-7 .notification-page-wrapper {
  padding-top: 17px;
}
.scroll-width-7 .geofence-modal-form-inner {
  margin-right: -7px;
}
.scroll-width-7 .notification-scroller {
  margin-right: -7px;
}

.scroll-width-8 .notification-page-wrapper {
  padding-top: 18px;
}
.scroll-width-8 .geofence-modal-form-inner {
  margin-right: -8px;
}
.scroll-width-8 .notification-scroller {
  margin-right: -8px;
}

.scroll-width-9 .notification-page-wrapper {
  padding-top: 19px;
}
.scroll-width-9 .geofence-modal-form-inner {
  margin-right: -9px;
}
.scroll-width-9 .notification-scroller {
  margin-right: -9px;
}

.scroll-width-10 .notification-page-wrapper {
  padding-top: 20px;
}
.scroll-width-10 .geofence-modal-form-inner {
  margin-right: -10px;
}
.scroll-width-10 .notification-scroller {
  margin-right: -10px;
}

.scroll-width-11 .notification-page-wrapper {
  padding-top: 21px;
}
.scroll-width-11 .geofence-modal-form-inner {
  margin-right: -11px;
}
.scroll-width-11 .notification-scroller {
  margin-right: -11px;
}

.scroll-width-12 .notification-page-wrapper {
  padding-top: 22px;
}
.scroll-width-12 .geofence-modal-form-inner {
  margin-right: -12px;
}
.scroll-width-12 .notification-scroller {
  margin-right: -12px;
}

.scroll-width-13 .notification-page-wrapper {
  padding-top: 23px;
}
.scroll-width-13 .geofence-modal-form-inner {
  margin-right: -13px;
}
.scroll-width-13 .notification-scroller {
  margin-right: -13px;
}

.scroll-width-14 .notification-page-wrapper {
  padding-top: 24px;
}
.scroll-width-14 .geofence-modal-form-inner {
  margin-right: -14px;
}
.scroll-width-14 .notification-scroller {
  margin-right: -14px;
}

.scroll-width-15 .notification-page-wrapper {
  padding-top: 25px;
}
.scroll-width-15 .geofence-modal-form-inner {
  margin-right: -15px;
}
.scroll-width-15 .notification-scroller {
  margin-right: -15px;
}

.scroll-width-16 .notification-page-wrapper {
  padding-top: 26px;
}
.scroll-width-16 .geofence-modal-form-inner {
  margin-right: -16px;
}
.scroll-width-16 .notification-scroller {
  margin-right: -16px;
}

.scroll-width-17 .notification-page-wrapper {
  padding-top: 27px;
}
.scroll-width-17 .geofence-modal-form-inner {
  margin-right: -17px;
}
.scroll-width-17 .notification-scroller {
  margin-right: -17px;
}

.scroll-width-18 .notification-page-wrapper {
  padding-top: 28px;
}
.scroll-width-18 .geofence-modal-form-inner {
  margin-right: -18px;
}
.scroll-width-18 .notification-scroller {
  margin-right: -18px;
}

.scroll-width-19 .notification-page-wrapper {
  padding-top: 29px;
}
.scroll-width-19 .geofence-modal-form-inner {
  margin-right: -19px;
}
.scroll-width-19 .notification-scroller {
  margin-right: -19px;
}

.scroll-width-20 .notification-page-wrapper {
  padding-top: 30px;
}
.scroll-width-20 .geofence-modal-form-inner {
  margin-right: -20px;
}
.scroll-width-20 .notification-scroller {
  margin-right: -20px;
}

.scroll-width-21 .notification-page-wrapper {
  padding-top: 31px;
}
.scroll-width-21 .geofence-modal-form-inner {
  margin-right: -21px;
}
.scroll-width-21 .notification-scroller {
  margin-right: -21px;
}

.scroll-width-22 .notification-page-wrapper {
  padding-top: 32px;
}
.scroll-width-22 .geofence-modal-form-inner {
  margin-right: -22px;
}
.scroll-width-22 .notification-scroller {
  margin-right: -22px;
}

.scroll-width-23 .notification-page-wrapper {
  padding-top: 33px;
}
.scroll-width-23 .geofence-modal-form-inner {
  margin-right: -23px;
}
.scroll-width-23 .notification-scroller {
  margin-right: -23px;
}

.scroll-width-24 .notification-page-wrapper {
  padding-top: 34px;
}
.scroll-width-24 .geofence-modal-form-inner {
  margin-right: -24px;
}
.scroll-width-24 .notification-scroller {
  margin-right: -24px;
}

.scroll-width-25 .notification-page-wrapper {
  padding-top: 35px;
}
.scroll-width-25 .geofence-modal-form-inner {
  margin-right: -25px;
}
.scroll-width-25 .notification-scroller {
  margin-right: -25px;
}

.scroll-width-26 .notification-page-wrapper {
  padding-top: 36px;
}
.scroll-width-26 .geofence-modal-form-inner {
  margin-right: -26px;
}
.scroll-width-26 .notification-scroller {
  margin-right: -26px;
}

.scroll-width-27 .notification-page-wrapper {
  padding-top: 37px;
}
.scroll-width-27 .geofence-modal-form-inner {
  margin-right: -27px;
}
.scroll-width-27 .notification-scroller {
  margin-right: -27px;
}

.scroll-width-28 .notification-page-wrapper {
  padding-top: 38px;
}
.scroll-width-28 .geofence-modal-form-inner {
  margin-right: -28px;
}
.scroll-width-28 .notification-scroller {
  margin-right: -28px;
}

.scroll-width-29 .notification-page-wrapper {
  padding-top: 39px;
}
.scroll-width-29 .geofence-modal-form-inner {
  margin-right: -29px;
}
.scroll-width-29 .notification-scroller {
  margin-right: -29px;
}

.scroll-width-30 .notification-page-wrapper {
  padding-top: 40px;
}
.scroll-width-30 .geofence-modal-form-inner {
  margin-right: -30px;
}
.scroll-width-30 .notification-scroller {
  margin-right: -30px;
}

.ref-marker {
  background: none;
}

.pos-name {
  position: absolute;
  width: 320px;
  left: 50%;
  margin-left: -160px;
  bottom: 100%;
  box-sizing: border-box;
  /* span {
    font-size: 12px;
    background: #fff;
    border-radius: 3px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
    padding: 6px;
    display: inline-block;
  } */
  display: none;
}

.marker:hover .pos-name {
  display: block;
}

.custom-marker.leaflet-marker-icon {
  background: none;
  border: 0;
}
.custom-marker.leaflet-marker-icon img {
  max-width: 100% !important;
  height: auto;
}

.hide-delete-btn .leaflet-draw-actions-bottom {
  display: none !important;
}

.form-group {
  margin-bottom: 25px;
}

.hilight {
  border: 1px solid transparent;
  color: #00c179;
  background: #fff;
  padding: 6px;
  display: inline-block;
  border-radius: 4px;
  margin: 6px 0;
}

.inline-buttons .theme-button,
.inline-buttons button {
  margin-right: 8px;
}

.ml-auto {
  margin-left: auto;
}

.page-subtitle-notification {
  font-weight: normal;
  margin: 0;
  padding: 0 0 4px;
  font-size: 14px;
}

.report-sidebar-switch:after {
  content: "";
  display: block;
  height: 1px;
  background: #fff;
  margin: 10px auto;
}
.report-sidebar-switch .theme-button {
  min-width: 70px !important;
  margin: 0 4px 0 0;
}
.report-sidebar-switch ~ .report-sidebar-switch:after {
  margin-bottom: 0;
}

.clearAllNotifcations {
  position: absolute;
  z-index: 999;
  background: #f7f7f7;
  border: 0;
  width: 100%;
  padding: 10px 30px;
  font-size: 16px;
  right: 10px;
  max-width: 300px;
  top: 153px;
  cursor: pointer;
  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.2);
}

.notifications-tr {
  margin-top: 143px;
}

.shown-clearall-btn .notifications-tr {
  margin-top: 195px;
}

.notification-visible {
  height: auto !important;
}

.notification-dismiss {
  font-size: 22px !important;
  line-height: 22px !important;
  width: 22px !important;
  height: 22px !important;
  background: none !important;
  top: 6.5px !important;
  right: 7px !important;
}

.progress-green,
.notification-success {
  background: #43a047 !important;
  border-color: #43a047 !important;
  color: #fff !important;
}

.progress-yellow,
.notification-warning {
  background: #ffa000 !important;
  border-color: #ffa000 !important;
  color: #fff !important;
}

.progress-red,
.notification-error {
  background: #d32f2f !important;
  border-color: #d32f2f !important;
  color: #fff !important;
}

.notification-info {
  background: #1976d2 !important;
  border-color: #1976d2 !important;
  color: #fff !important;
}

.notification-title {
  color: #fff !important;
}

.notification-visible {
  color: #fff !important;
  padding: 8px 16px !important;
  font-size: 14px !important;
  letter-spacing: 0.01071em;
  line-height: 1.43;
  border-radius: 4px !important;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;
}
.notification-visible:hover .notification-dismiss {
  display: block;
}

.notification-inner-box {
  border-radius: 4px;
  margin: -10px -16px -8px;
  padding: 10px 16px 8px;
}

.alt-title {
  font-family: "Bebas Neue", sans-serif;
  font-weight: 500;
}

.tab-title {
  font-family: "Bebas Neue", sans-serif;
  font-weight: normal;
  font-size: 24px;
  padding: 16px 0 5px;
  margin: 0;
  border-radius: 6px 6px 0 0;
}

.text-danger {
  color: #d32f2f;
}

.text-center {
  text-align: center;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: right;
}

.text-default {
  color: inherit;
}

.table-fields-list .smooth-dnd-draggable-wrapper:nth-child(odd) {
  background: #fafafa;
}
.table-fields-list .smooth-dnd-draggable-wrapper .selected_item {
  background: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
}

.main-menu-list-wrapper ul {
  padding: 0;
  overflow: hidden;
}

.theme-input-select {
  height: 36px !important;
  font-size: 12px !important;
  padding: 0 !important;
  display: flex !important;
  border-radius: 0 !important;
}

.theme-label {
  font-size: 14px;
}

.theme-label-shrink {
  margin-top: 0;
}

.theme-label-focused {
  margin-top: 0;
}

.selector-list li {
  margin-bottom: 6px;
}

.MuiTab-root {
  font-family: Inter, sans-serif !important;
  font-size: 12px !important;
}

.theme-textarea {
  font-size: 14px;
  padding: 0;
}

.rv-xy-plot,
.theme-cssOutlinedInput {
  color: inherit;
}

.rv-xy-plot__axis text,
.alt-x-label text,
.alt-y-label text {
  fill: currentColor;
}

.rv-xy-plot__axis line,
.rv-xy-plot__grid-lines line {
  stroke: currentColor;
}

.main-content-page-inner {
  padding: 20px 26px;
}

.v-checkbox {
  display: inline-block;
  width: 18px !important;
  height: 18px !important;
  text-align: center;
  border: 1px solid;
  border-radius: 3px;
}

.MuiOutlinedInput-notchedOutline,
.theme-notchedOutline {
  box-shadow: none;
  border-radius: 4px !important;
}

.button-small {
  min-height: 28px;
  padding-left: 16px;
  padding-right: 16px;
}

.tab-container-outer .custom-tabs-root {
  margin-left: -15px;
  margin-right: -15px;
  margin-top: 4px;
}

.button-with-icon {
  width: 110px;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
}
.button-with-icon span,
.button-with-icon svg {
  font-weight: normal;
  font-size: 14px;
  line-height: normal;
  text-transform: none;
  white-space: normal;
  display: block;
  text-align: center;
}
.button-with-icon svg {
  margin: 0 auto 10px;
}

.driver-page-content {
  border-radius: 6px 0 0 6px;
  height: 100%;
}
.driver-page-content .page-title-inverse {
  width: 260px;
}

.show-tracks,
.show-points {
  display: inline-flex;
  align-items: center;
  padding: 0 10px 0 0;
}

span.form-control-label,
.form-control-label {
  color: inherit;
}

.material-icons {
  vertical-align: middle;
  color: inherit;
  font-family: "Material Icons";
}

.row-value {
  font-weight: bold;
  display: inline-block;
  font-size: 14px;
}

.row-label {
  font-size: 12px;
  font-weight: normal;
  min-width: 175px;
  display: inline-block;
}

.license-card-img {
  width: 60px;
  height: 60px;
  text-align: center;
  padding: 8px;
  border-radius: 6px;
}

.attribute-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.attribute-list li {
  margin-bottom: 10px;
  border-radius: 6px;
  display: flex;
  flex-wrap: wrap;
}

.attribute-list .row-label {
  margin-bottom: 5px;
  min-width: inherit;
}

.attribute-list .row-value {
  font-weight: 700;
  font-size: 12px;
  margin-left: auto;
}

.trackers-list {
  list-style: none;
  margin: 0 0 0 -16px;
  padding: 0;
  text-align: center;
}

.trackers-list li {
  box-sizing: border-box;
  border-radius: 6px;
  width: calc(25% - 16px);
  float: left;
  margin-left: 16px;
  margin-bottom: 16px;
  padding: 0;
}

.trackers-list .row-label {
  font-size: 12px;
  font-weight: normal;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: inherit;
}

.trackers-list .row-value {
  font-size: 12px;
}

.row-image {
  width: 80px;
  height: 80px;
}

.license-card-detail p {
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0;
}

.license-card-detail .row-label {
  margin-bottom: 5px;
}

.license-card-detail .row-value {
  text-align: right;
  margin-left: auto;
}

.license-card-detail {
  font-size: 12px;
  padding: 0 0 10px;
  margin-bottom: 30px;
}

.MuiSkeleton-pulse {
  animation: MuiSkeleton-keyframes-pulse 1.5s ease-in-out 0.5s infinite;
}
.skeleton-wave {
  overflow: hidden;
  position: relative;
}

.skeleton-wave::after {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  content: "";
  z-index: 1;
  position: absolute;
  animation: MuiSkeleton-keyframes-wave 2.6s linear 0.5s infinite;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.04), transparent);
}

.geofence-modal {
  /*   &.hide-delete-btn {
     .leaflet-draw-edit-remove {
       display: none;
     }
   }
  */
  display: flex;
}
.geofence-modal-form {
  position: relative;
  width: 275px;
  z-index: 9999;
  font-size: 12px;
  overflow: hidden;
}
.geofence-modal-form-inner {
  height: 310px;
  overflow-y: scroll;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  right: -1px;
  position: relative;
}
.geofence-modal-form-inner > div {
  padding: 0 12px;
}
.geofence-modal-form-inner > div:nth-child(even) {
  background: rgba(255, 255, 255, 0.15);
}
.geofence-modal-form .ScrollbarsCustom-Wrapper {
  right: 0 !important;
}
.geofence-modal-form .ScrollbarsCustom-Content {
  padding: 12px !important;
}
.geofence-modal-form-footer {
  width: 100%;
  text-align: right;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  padding: 10px;
}
.dialog-full-screen .geofence-modal .geofence-modal-form .geofence-modal-form-inner {
  height: calc(100% - 50px);
}
.geofence-modal-map {
  flex: 1 1;
}
.dialog-full-screen .geofence-modal {
  height: calc(100vh - 44px);
}

.notification-wizard {
  margin: 0;
  padding: 0;
}
.notification-wizard .theme-button {
  border-radius: 0;
  padding: 8px 15px;
  font-size: 15px;
  text-transform: none;
}
.notification-wizard .theme-button svg {
  display: block;
}
.notification-wizard .theme-button .row-related-icon {
  margin-left: auto;
  transform: rotate(-90deg);
}
.notification-wizard .theme-button.active .row-related-icon {
  transform: rotate(0);
}
.notification-wizard li {
  margin-top: 6px;
}

.notification-wizard-inner {
  list-style: none;
  margin: 0;
  padding: 0;
}
.notification-wizard-inner .theme-button {
  font-size: 13px;
  border-radius: 0;
  padding: 8px 15px 8px 35px;
}
.notification-wizard-inner .custom-indicator {
  background: #fff !important;
}

.maintenance-page .fms-sidebar .list-view {
  padding: 0;
}

.unread {
  cursor: pointer;
}

.unread .read-unread-mark {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  float: right;
}

.maintain-height {
  margin-top: 28px;
}

.notification-head-row {
  padding: 5px 10px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  font-weight: bold;
  display: flex;
  align-items: center;
}

@keyframes MuiSkeleton-keyframes-wave {
  0% {
    transform: translateX(-100%);
  }
  60% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(100%);
  }
}
.skeleton-pulse {
  animation: MuiSkeleton-keyframes-pulse 1.5s ease-in-out 0.5s infinite;
}

@keyframes MuiSkeleton-keyframes-pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
.alert {
  padding: 6px 9px;
  border: 1px solid;
  border-radius: 4px;
  margin: 20px auto;
  font-size: 12px;
}
.alert svg {
  vertical-align: middle;
  margin-right: 6px;
}

.graph-total-unit {
  font-size: 1.5em;
  font-weight: bold;
}

.notification-model-common-section {
  padding-left: 10px;
}
.notification-model-common-section.opened {
  height: 100%;
}

.highcharts-data-label .pie-tooltip {
  display: flex;
}
.highcharts-data-label .pie-tooltip-image {
  width: 26px;
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 4px;
  padding: 5px;
}
.highcharts-data-label .pie-tooltip-label {
  padding-left: 10px;
  font-family: Inter, sans-serif;
  align-items: center;
  display: flex;
}
.highcharts-data-label .pie-tooltip-label b {
  font-size: 1.8em;
  font-weight: 900;
  padding-right: 7px;
}
.highcharts-data-label .pie-tooltip-half-1 .pie-tooltip-image {
  order: 1;
}
.highcharts-data-label .pie-tooltip-half-1 .pie-tooltip-label {
  order: 0;
  padding-left: 0;
  padding-right: 10px;
  text-align: right;
}

.highcharts-text-outline {
  display: none;
}

.scroll-auto {
  overflow: auto !important;
}

.scroll-visible {
  overflow: visible !important;
}

.motion-status-bar {
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.motion-status-bar .motion-status-img {
  margin-right: 10px;
}
.motion-status-bar .motion-status-name {
  min-width: 0;
  margin-right: 10px;
  font-size: 12px;
  font-weight: bold;
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.motion-status-bar img {
  width: 20px;
  height: 20px;
}
.motion-status-bar .motion-status-border {
  width: 18px;
  border-radius: 9px;
  height: 18px;
  margin-right: 10px;
}
.motion-status-bar .motion-status-count {
  font-weight: bold;
  margin-left: auto;
  font-size: 18px;
  font-weight: 700;
  padding-right: 4px;
  font-style: italic;
}
.motion-status-bar .motion-status-currency {
  font-weight: bold;
  margin-left: auto;
  font-weight: normal;
  font-size: 12px;
  padding-right: 4px;
  font-style: italic;
}
.motion-status-bar.multi-columns {
  margin-top: 5px;
  width: calc(50% - 2.5px);
}
.motion-status-bar.multi-columns .motion-status-border {
  margin-right: 8px;
}
.motion-status-bar.multi-columns .motion-status-img {
  margin-right: 8px;
}
.motion-status-bar.multi-columns .motion-status-img img {
  width: 26px;
  height: 26px;
}

.multi-columns-wrap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.driver-state-wrap > h3 {
  font-size: 2em;
  margin-bottom: 0;
}
.driver-state-wrap > p {
  font-size: 1.3em;
  margin: 0 0 16px;
}
.driver-state-wrap .driver-state-container {
  display: flex;
  flex: 1 1;
  flex-wrap: wrap;
  margin-left: -12px;
}
.driver-state-wrap .maintenace-state-container {
  gap: 3px;
  margin: 0;
}
.driver-state-wrap .driver-state,
.driver-state-wrap .driver-state2 {
  width: calc(50% - 12px);
  margin-left: 12px;
  margin-bottom: 12px;
  padding: 17px 15px 10px;
  border-radius: 6px;
  text-align: center;
  color: #fff;
}
.driver-state-wrap .driver-state h3,
.driver-state-wrap .driver-state2 h3 {
  font-size: 18px;
  margin-bottom: 5px;
  margin-top: 10px;
}
.driver-state-wrap .driver-state p,
.driver-state-wrap .driver-state2 p {
  margin-top: 5px;
}
.driver-state-wrap .driver-state.online,
.driver-state-wrap .driver-state2.online {
  background: #28a745;
}
.driver-state-wrap .driver-state.offline,
.driver-state-wrap .driver-state2.offline {
  background: #dc3545;
}
.driver-state-wrap .driver-state.not-register,
.driver-state-wrap .driver-state2.not-register {
  background: #566374;
}
.driver-state-wrap .driver-state.not-update,
.driver-state-wrap .driver-state2.not-update {
  background: #1976d2;
}
.driver-state-wrap .driver-state-inline {
  min-width: 80px;
  flex: 1 1;
  margin-left: 0;
  padding: 18px 3px;
  border-radius: 0;
}
.driver-state-wrap .driver-state-inline h3 {
  margin-bottom: 0;
  margin-top: 5px;
  font-size: 21px;
}
.driver-state-wrap .driver-state-inline p {
  font-size: 14px;
  margin-top: 0;
}
.driver-state-wrap {
  /* .driver-state {
    width: calc(50% - 24px);
    margin-left: 16px;
    margin-bottom: 12px;
    padding: 10px;
    border-radius: 6px;
    img {
      margin-top: 3px;
      float: left;
    }
    h3 {
      font-size: 20px;
      margin: 0;
      margin-left: 45px;
    }
    p {
      margin-top: 0;
      margin-bottom: 0;
      margin-left: 45px;
    }
  } */
}

.button-to-normal {
  cursor: pointer;
  background: none;
  border: 0;
  color: inherit;
  font-size: 18px;
  padding: 0 0 0 10px;
  vertical-align: middle;
}

.MuiDialog-paper {
  overflow-y: visible !important;
}

.theme-range-slider {
  height: 8px !important;
}

.theme-range-slider .theme-range-slider-thumb {
  height: 24px;
  width: 24px;
  background-color: #fff;
  border: 2px solid currentColor;
  margin-top: -8px;
  margin-left: -12px;
}

.theme-range-slider .theme-range-slider-label {
  left: calc(-50% + 4px);
  top: -22px;
  /* span {
    color: inherit;
  } */
}

/* .theme-range-slider .theme-range-slider-label * {
  background: transparent;
} */
.theme-range-slider .theme-range-slider-rail,
.theme-range-slider .theme-range-slider-track {
  height: 8px;
  border-radius: 4px;
}

.fake-calendar {
  margin: 0;
  padding: 0;
  list-style: none;
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  border-left: 1px solid rgba(0, 0, 0, 0.15);
}
.fake-calendar li {
  float: left;
  width: 20%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid rgba(0, 0, 0, 0.15);
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}
.fake-calendar label {
  cursor: pointer;
  display: inline-block;
  width: 2em;
  height: 2em;
  text-align: center;
  line-height: 2;
  border-radius: 40px;
}
.fake-calendar .selected-day label {
  background: rgba(0, 0, 0, 0.25);
}
.fake-calendar .highlight label {
  background: rgba(0, 0, 0, 0.5);
}

.fake-calendar-result {
  float: right;
  margin-bottom: 10px;
}

.rta__autocomplete {
  color: #333;
  z-index: 99;
}

.rta__list {
  max-height: 150px;
  border: 0;
  overflow: auto;
}

.rta__entity {
  padding: 6px 12px;
  font-size: 0.8em;
}

.menu_item_text_inner {
  text-align: left;
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgba(255, 255, 255, 0.5);
}

::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(255, 255, 255, 0.5);
}

:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(255, 255, 255, 0.5);
}

:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(255, 255, 255, 0.5);
}

.react-time-picker__clear-button {
  display: none;
}

.react-time-picker__wrapper {
  padding: 2px 10px 3px;
  border-radius: 4px;
}

.react-time-picker__inputGroup__input {
  outline: 0;
}

.custom-unit-tabpanel-container {
  padding-bottom: 20px;
}

.messages-table {
  font-size: 12px;
}

.theme-builder-module {
  padding: 20px;
}
.theme-builder-module h1 {
  margin: 0 0 10px;
}

.dnd-ebuilder {
  padding: 15px;
  border-radius: 6px;
}
.dnd-ebuilder h3 {
  margin-top: 4px;
  margin-bottom: 0;
}
.dnd-ebuilder h4 {
  margin-top: 5px;
  margin-bottom: 5px;
}
.dnd-ebuilder .dnd-drop {
  border: 1px dashed;
  border-radius: 6px;
  padding: 15px;
  border-radius: 6px;
  min-height: 100px;
}
.dnd-ebuilder .dnd-dropable {
  background: rgba(0, 0, 0, 0.15);
}
.dnd-ebuilder .tag {
  border-radius: 4px;
  padding: 6px 12px;
  margin-right: 8px;
  display: inline-block;
  vertical-align: middle;
}
.dnd-ebuilder .dropable-placehoder {
  border: 1px dashed;
  padding: 4px 12px;
  height: 2em;
  min-width: 120px;
  display: inline-block;
  vertical-align: middle;
}
.dnd-ebuilder .dnd-placeholder {
  margin-bottom: 0;
  position: relative;
}
.dnd-ebuilder .dnd-placeholder p {
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 5px;
}
.dnd-ebuilder .dnd-box {
  margin-right: 0.5rem;
  padding: 0.25rem 0.75rem;
  margin-bottom: 0.5rem;
  border-radius: 3px;
  cursor: move;
  display: inline-block;
}
.dnd-ebuilder .text-right .dnd-box {
  margin-right: 0;
  margin-left: 1rem;
}
.dnd-ebuilder .dnd-empty {
  text-align: center;
}
.dnd-ebuilder .dnd-empty h2 {
  font-size: 1em;
  margin-top: 0;
}
.dnd-ebuilder .dnd-empty svg {
  width: 40px;
}
.dnd-ebuilder .action-rollback-btn {
  position: absolute;
  top: 9px;
  right: 1px;
}

.feature-close-button {
  position: absolute;
  margin-top: 6px;
  right: 15px;
  top: 3px;
  font-size: 24px !important;
  cursor: pointer;
}

.driver-modal-fixed,
.feature-row-1,
.feature-row {
  position: fixed;
  bottom: 24px;
  top: 49px;
  left: 378px;
  width: 306px;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  border-radius: 0;
}

.feature-row-1,
.driver-modal-fixed {
  left: 306px;
}

.feature-row-head {
  padding: 6px 19px;
  font-weight: 500;
  font-family: "Bebas Neue", sans-serif;
  font-size: 24px;
  line-height: 36px;
}
.feature-row-head img {
  vertical-align: top;
  margin-right: 15px;
}
.feature-row-head .feature-row-head-name {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  vertical-align: top;
}
.feature-row-head .feature-row-head-name.status {
  font-size: 12px;
  font-style: italic;
  font-weight: normal;
  display: flex;
  align-items: center;
  font-family: Inter, sans-serif;
  gap: 5px;
}

.feature-row-inner {
  height: calc(100vh - 48px - 24px - 97px);
}

.feature-section {
  display: block;
  vertical-align: top;
  font-size: 11px;
  line-height: 1.4;
  position: relative;
  transition: all 0.3s ease;
}
.feature-section .item-row {
  font-size: 12px;
  line-height: 24px;
  font-weight: 300;
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 8px;
}
.feature-section .item-row svg {
  width: 18px;
  height: 18px;
}
.feature-section .item-row .row-label {
  display: block;
  min-width: inherit;
  margin: 0;
  line-height: 1.1;
  min-width: 100px;
}
.feature-section .item-row .row-value {
  font-size: 12px;
  margin: 0;
  line-height: 1.1;
}
.feature-section h3 {
  padding: 7px 0 0;
  font-size: 18px;
  margin: 0 10px;
  font-weight: 500;
}
.feature-section {
  /* &:hover {
  	//z-index: 1;
  	//transform: scale(1.02);
  	.feature-section-close {
  		display: block;
  	}
  } */
}
.feature-section .list-unstyled {
  margin: 0;
  padding: 0;
}

.fms-notification-inner {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.collapseable {
  margin-bottom: 4px;
  min-height: 50px;
}
.collapseable .feature-row-head {
  font-family: "Bebas Neue", sans-serif;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/****** Chat Popup Layout ******/
.msg_head,
.boxhandle-icon {
  cursor: move;
}

.msg_box {
  position: fixed;
  bottom: 30px;
  overflow: hidden;
  z-index: 9999999;
  border: 1px solid rgba(0, 0, 0, 0.5);
  background: #fff;
}

.msg_head {
  align-items: center;
  font-weight: bold;
  font-size: 12px;
  display: flex;
}
.msg_head > div {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.msg_head .msg-unit-icon {
  width: 30px;
  height: 30px;
}

.closebox {
  cursor: pointer;
  padding: 3px;
}
.closebox:hover {
  background: rgba(0, 0, 0, 0.15);
}
.closebox svg {
  fill: currentColor;
  width: 24px;
  height: 24px;
  display: block;
}

.boxhandle-icon {
  height: 10px;
}

.react-contextmenu.react-contextmenu--visible {
  min-width: 220px;
  background: #fff;
  border: solid 1px #DADCE0;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.04);
}

.react-contextmenu .react-contextmenu-item {
  cursor: pointer;
  display: block;
  padding: 5px 40px;
  font-size: 11px;
  font-weight: normal;
  color: #202124;
}
.react-contextmenu .react-contextmenu-item--selected {
  background: #C8C8C9;
}

.modal-buttons {
  display: flex;
  gap: 10px;
}

.sensors-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 172px;
  margin-left: 20px;
}
.sensors-buttons .theme-button {
  width: 100%;
  box-shadow: none;
  border-top: 5px solid transparent;
  border-radius: 0;
}

@media (max-width: 959px) {
  .show-tracks,
  .show-points {
    display: none;
  }
  .leaflet-top.leaflet-right {
    top: 0;
  }
}
@media (max-width: 767px) {
  .main-content-page {
    margin-top: 0;
    margin-left: 8px;
  }
  .v-filter-field2 {
    flex-wrap: wrap;
    row-gap: 0;
  }
  .v-filter-field2 > div {
    min-width: 90px;
  }
  .sidebar-icon-gap {
    padding-left: 0 !important;
  }
  .license-card-img {
    float: none;
    width: auto;
  }
  .license-card-detail {
    margin-left: 0;
  }
  .sidebar-collapse-button {
    top: 0;
    margin-top: 3px;
  }
  .logo-section {
    margin-left: 42px;
  }
}
@media (max-width: 479px) {
  .trackers-list li {
    width: calc(100% - 16px);
  }
}
@media (max-width: 959px) {
  .driver-page-content {
    border-radius: 6px;
  }
}
.react-base-table {
  table-layout: fixed;
  border-collapse: collapse;
}
.react-base-table .MuiSvgIcon-root {
  display: block;
}
.react-base-table .MuiTableCell-sizeSmall:last-child,
.react-base-table .MuiTableCell-sizeSmall {
  padding: 6px;
}
.react-base-table a,
.react-base-table .MuiTableCell-root {
  color: inherit;
  position: relative;
  border-bottom: 0;
}
.react-base-table .MuiTableCell-head {
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
}
.react-base-table .MuiTableCell-body {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.react-base-table.custom-table .MuiTableCell-body {
  overflow: visible;
  white-space: nowrap;
}
.react-base-table.custom-table .MuiTableCell-body a {
  display: inline-block;
}
.react-base-table .MuiTableCell-head {
  white-space: normal;
}
.react-base-table .MuiTableCell-body a {
  display: block;
  overflow: inherit;
  text-overflow: inherit;
  white-space: inherit;
}

.react-base-table-wrapper .resizer {
  display: block;
  width: 10px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
  touch-action: none;
}
.react-base-table-wrapper .resizer.isResizing {
  background: rgba(0, 0, 0, 0.05);
}
.react-base-table-wrapper .MuiPaginationItem-root,
.react-base-table-wrapper .MuiTablePagination-root,
.react-base-table-wrapper .MuiPaginationItem-root {
  color: inherit;
}
.react-base-table-wrapper .MuiTablePagination-actions .MuiIconButton-root {
  padding: 3px;
}
.react-base-table-wrapper .MuiTablePagination-toolbar {
  min-height: 40px;
}
.react-base-table-wrapper .MuiPaginationItem-root {
  height: 27px;
  min-width: 27px;
}

.btn-link {
  font-size: 0.8em;
  padding: 0 4px;
  color: currentColor;
  padding: 5px 10px;
  background: rgba(255, 255, 255, 0.25);
  margin-right: 6px;
  border-radius: 4px;
}
.btn-link.active {
  font-weight: bold;
}

.search-field {
  position: absolute;
  right: 10px;
  top: 54px;
  z-index: 9999;
  background-clip: padding-box;
  background-color: #fff;
  border-radius: 4px;
}
.search-field [class*=control] {
  border: 1px solid rgba(30, 114, 184, 0.3019607843);
  background-color: rgba(30, 114, 184, 0.1019607843);
  min-height: 36px;
}

.navbar-indicator {
  background-color: transparent;
}

.navbar-selected {
  background-color: rgba(0, 0, 0, 0.1);
  font-weight: bold;
}

.stat-block {
  min-width: 120px;
  margin-bottom: 12px;
  padding: 17px 15px;
  border-radius: 6px;
  text-align: center;
  margin-right: 12px;
}
.stat-block p {
  margin-bottom: 0;
  margin-top: 0;
  font-size: 30px;
  font-weight: bold;
}
.stat-block span {
  margin-top: 0;
  font-size: 11px;
}

.loading-dot {
  font-size: 4px;
  animation: selectLoader 1s ease-in-out 0ms infinite;
  background-color: currentColor;
  border-radius: 1em;
  display: inline-block;
  height: 1em;
  vertical-align: middle;
  width: 1em;
}
.loading-dot ~ .loading-dot {
  margin-left: 1em;
}

@keyframes selectLoader {
  0%, 80%, 100% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
}
.loading-status-text {
  display: inline-flex;
  align-items: center;
  margin-left: 10px;
}
.loading-status-text .status-icon {
  margin-right: 5px;
}

.process-list {
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: space-between;
}
.process-list li {
  display: inline-flex;
  align-items: center;
}

.custom-badge {
  padding: 2px 8px 4px;
  border-radius: 14px;
  background: #d32f2f;
  color: #fff;
  line-height: 1;
  font-weight: bold;
}
.custom-badge.on {
  background: #28A745;
}

.custom-tabs-root .MuiTabScrollButton-root.Mui-disabled,
.custom-tabs .MuiTabScrollButton-root.Mui-disabled {
  display: none;
}

.custom-mileage-list {
  padding: 5px 12px;
  border-radius: 6px;
  margin-top: 7px;
}
.custom-mileage-list span {
  display: block;
  text-align: center;
  padding: 5px 0;
}
.custom-mileage-list span ~ span {
  border-top-width: 1px;
  border-top-style: dashed;
}

.MuiLinearProgress-root.MuiLinearProgress-determinate {
  background: #E9EAEB;
  border-radius: 4px;
  margin-top: 4px;
}
.MuiLinearProgress-root.MuiLinearProgress-determinate .MuiLinearProgress-bar {
  border-radius: 4px;
}

.light-blue .MuiLinearProgress-bar {
  background-color: #4DCEF0;
}

.purple .MuiLinearProgress-bar {
  background-color: #B31EFC;
}

.success .MuiLinearProgress-bar {
  background-color: #28A745;
}

.danger .MuiLinearProgress-bar {
  background-color: #DC3545;
}

.primary .MuiLinearProgress-bar {
  background-color: #0288D1;
}

.warning .MuiLinearProgress-bar {
  background-color: #E6B535;
}

.MuiTableCell-root.text-success {
  font-weight: bold;
  color: #28A745;
}
.MuiTableCell-root.text-danger {
  font-weight: bold;
  color: #DC3545;
}
.MuiTableCell-root.text-primary {
  font-weight: bold;
  color: #0288D1;
}
.MuiTableCell-root.text-warning {
  font-weight: bold;
  color: #E6B535;
}

.md-table .MuiTableCell-root {
  font-size: 16px;
}
.md-table .MuiTableCell-head {
  font-size: 18px;
  font-weight: bold;
}
.md-table .row-label {
  font-size: inherit;
}

.black-warning.MuiLinearProgress-root {
  background-color: #fff;
}

.black-warning .MuiLinearProgress-bar {
  background-color: #000;
}
.black-warning .MuiLinearProgress-bar:after {
  content: "";
  display: block;
  height: 100%;
  width: 100%;
  left: 100%;
  margin-left: 12px;
  position: absolute;
  border-radius: 4px;
  background-color: #E6B535;
}

.section-title {
  font-size: 18px;
  margin-bottom: 7px;
  gap: 10px;
  display: flex;
}

.md-bar-graphlist {
  list-style: none;
  margin: 0;
  padding: 0;
  padding-top: 5px;
  padding-bottom: 5px;
}
.md-bar-graphlist li {
  padding: 5px 0;
}
.md-bar-graphlist .row-label {
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 7px;
}
.md-bar-graphlist .row-value {
  font-size: 16px;
}
.md-bar-graphlist .row-label-sm {
  font-size: 12px;
  margin-top: 5px;
}

.md-category-list {
  list-style: none;
  margin: 0;
  padding: 0;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 2px dashed rgba(112, 112, 112, 0.2);
}
.md-category-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}
.md-category-list li ~ li {
  border-top: 1px solid #E9EAEB;
}
.md-category-list .row-label {
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 7px;
}
.md-category-list .row-value {
  font-size: 16px;
  font-weight: 700;
}

.md-col-first {
  padding: 12px;
  height: calc(100vh - 48px - 24px);
}

.md-col-second {
  padding: 12px;
}

.motion-status-bar-inline {
  padding-bottom: 0;
  flex-direction: column;
  width: 70px;
  border-bottom: 0 !important;
  text-align: center;
  padding: 0 5px;
}
.motion-status-bar-inline > * {
  margin-left: auto !important;
  margin-right: auto !important;
}
.motion-status-bar-inline .motion-status-border {
  width: 38px;
  height: 6px;
}
.motion-status-bar-inline img {
  width: 42px;
  height: 42px;
}
.motion-status-bar-inline .motion-status-name,
.motion-status-bar-inline .motion-status-count {
  text-align: center;
  margin: auto;
  order: -1;
  font-style: normal;
}
.motion-status-bar-inline .motion-status-name {
  min-width: 0;
  width: 100%;
  margin: 5px auto;
}
.motion-status-bar-inline .motion-status-count {
  font-size: 16px;
  margin-bottom: 10px;
}

.trackYVisible .ScrollbarsCustom-TrackY {
  max-width: 4px;
}

.ScrollbarsCustom-Wrapper {
  inset: 0 !important;
}

.MuiList-padding.MuiMenu-list {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/main.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAQA;;;;;;;sCAAA;AAUA;EAAmB,oCAAA;AARnB;;AASA;EAAmB,oCAAA;AALnB;;AAMA;EAAmB,qCAAA;AAFnB;;AAGA;EACE,sBAAA;AAAF;;AAGA;EACE,uBAAA;EAAA,mBAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,SAAA;EACA,UAAA;EACA,8BCyDe;EDxDf,mCAAA;EACA,kCAAA;AAAF;;AAIA;EACE,6BAAA;AADF;;AAIA;EACE,6CAAA;AADF;;AAIA;EACE,6CAAA;AADF;;AAIA;EACE,6CAAA;AADF;;AAIA;EACE,4CAAA;AADF;;AAIA;EACE,4CAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAGA;EACE,kBAAA;EACA,eCSa;EDRb,mBAAA;AAAF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AACF;AASE;EACE,cAAA;AAPJ;AASE;EACE,cAAA;AAPJ;AASE;EACE,cAAA;AAPJ;AASE;EACE,iBAAA;EACA,sBAAA;AAPJ;AASE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAPJ;AAQI;EACE,SAAA;AANN;AASE;EACE,aAAA;EACA,8BAAA;EACA,wBAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;AAPJ;AASE;;EAEE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAPJ;AAQI;;EACE,uBAAA;EACA,0BAAA;EACA,mBAAA;AALN;AAOI;;EACE,SAAA;AAJN;AAQE;EACE,aAAA;AANJ;AAOI;EACE,kBAAA;AALN;AAQE;EACE,qBAAA;EACA,wBAAA;EACA,aAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;AANJ;AAOI;EACE,kBAAA;AALN;AAOI;EACE,gBAAA;AALN;;AASA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AANF;AAOE;EACE,cAAA;AALJ;AAOE;EACE,aAAA;EACA,8BAAA;EACA,wBAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AALJ;AAOE;EACE,aAAA;EACA,QAAA;EACA,yBAAA;EACA,iBAAA;AALJ;AAMI;EACE,kBAAA;AAJN;AAMI;EACE,gBAAA;AAJN;AAOE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AALJ;;AAUA;EACE,oBAAA;AAPF;;AAUA;EACE,+EAAA;AAPF;;AAWA;EAEE,qBAAA;AATF;AAWE;EACE,qBAAA;AATJ;;AAaA;EACE,gBAAA;AAVF;;AAaA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,WCvKW;EDwKX,eC3Ia;ED4Ib,gBC1KS;ED2KT,kBAAA;EACA,kBAAA;AAVF;;AAaA;EACE,cChOW;ADsNb;;AAeE;EAEE,cAAA;EACA,YAAA;EACA,WAAA;AAbJ;;AAiBA;EACE,WAAA;AAdF;;AAiBA;EACE,YAAA;AAdF;;AAiBA;EACE,eCxKa;AD0Jf;;AAiBA;EACE,kBAAA;AAdF;;AAiBA;;EAEE,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,SAAA;AAdF;;AAiBA;EACE,yBAAA;EAGA,iBAAA;EACA,SAAA;AAdF;AAiBE;EACE,aAAA;AAfJ;AAkBE;EACE,iBAAA;AAhBJ;AAmBE;EACE,mBAAA;EACA,eAAA;EACA,aAAA;AAjBJ;AAmBI;EACE,YAAA;EACA,oBAAA;AAjBN;AAoBI;EACE,aAAA;AAlBN;AAuBI;EACE,qBAAA;AArBN;AAsBM;EAAM,cAAA;AAnBZ;AAsBI;EACE,aAAA;AApBN;;AA0BA;EACE,kBAAA;AAvBF;AAyBE;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,6BAAA;EACA,eAAA;AAvBJ;;AA2BA;EACE,mBAAA;AAxBF;;AA2BA;EACE,qBAAA;EACA,YAAA;AAxBF;;AA2BA;EACE,kBAAA;EACA,SAAA;EACA,gBCnRY;EDoRZ,iCAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;EACA,UAAA;AAxBF;AA0BE;EACE,eAAA;EACA,WCjUQ;EDkUR,qBAAA;EACA,cAAA;AAxBJ;AA2BM;EACE,cAAA;AAzBR;AA8BE;;EAEE,sBAAA;EACA,qBAAA;AA5BJ;AA+BE;EACE,kBAAA;EACA,oBAAA;EACA,cAAA;AA7BJ;AAgCE;EACE,UAAA;EACA,QAAA;AA9BJ;AAiCE;EACE,MAAA;EACA,UAAA;AA/BJ;AAkCE;EACE,MAAA;EACA,WAAA;EACA,UAAA;AAhCJ;AAmCE;EACE,YAAA;EACA,SAAA;AAjCJ;AAoCE;EACE,YAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;AAlCJ;AAqCE;EACE,gBAAA;AAnCJ;AAsCE;EACE,cAAA;EACA,SAAA;AApCJ;AAsCI;EACE,sBAAA;EACA,iBAAA;AApCN;AAwCE;EACE,iBAAA;EACA,WAAA;AAtCJ;;AA0CA;EACE,cAAA;AAvCF;;AA0CA;EACE,8CAAA;AAvCF;;AA0CA;;;EAGE,gBCzYQ;ED0YR,cChbW;ADyYb;;AA0CA;EACE,SAAA;EACA,YAAA;EACA,mBAAA;AAvCF;;AA0CA;EACE,iCAAA;AAvCF;;AA0CA;EACE,iCAAA;AAvCF;AAyCE;EACE,2BAAA;AAvCJ;;AA2CA;EACE,yBAAA;AAxCF;;AA2CA;EACE,gBAAA;EACA,eAAA;EACA,UAAA;AAxCF;AA0CE;EACE,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AAxCJ;AA2CE;EACE,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,sBAAA;AAzCJ;;AA8CE;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA;;KAAA;AAzCJ;;AA+CA;;;EAAA;AAKE;EACE,+BAAA;AA7CJ;AA+CI;EACE,yBAAA;AA7CN;;AAyCE;EACE,+BAAA;AAtCJ;AAwCI;EACE,yBAAA;AAtCN;;AAkCE;EACE,+BAAA;AA/BJ;AAiCI;EACE,yBAAA;AA/BN;;AA2BE;EACE,+BAAA;AAxBJ;AA0BI;EACE,yBAAA;AAxBN;;AAoBE;EACE,+BAAA;AAjBJ;AAmBI;EACE,yBAAA;AAjBN;;AAaE;EACE,+BAAA;AAVJ;AAYI;EACE,yBAAA;AAVN;;AAME;EACE,+BAAA;AAHJ;AAKI;EACE,yBAAA;AAHN;;AADE;EACE,+BAAA;AAIJ;AAFI;EACE,yBAAA;AAIN;;AARE;EACE,+BAAA;AAWJ;AATI;EACE,yBAAA;AAWN;;AAfE;EACE,gCAAA;AAkBJ;AAhBI;EACE,0BAAA;AAkBN;;AAtBE;EACE,gCAAA;AAyBJ;AAvBI;EACE,0BAAA;AAyBN;;AA7BE;EACE,gCAAA;AAgCJ;AA9BI;EACE,0BAAA;AAgCN;;AApCE;EACE,gCAAA;AAuCJ;AArCI;EACE,0BAAA;AAuCN;;AA3CE;EACE,gCAAA;AA8CJ;AA5CI;EACE,0BAAA;AA8CN;;AAlDE;EACE,gCAAA;AAqDJ;AAnDI;EACE,0BAAA;AAqDN;;AAzDE;EACE,gCAAA;AA4DJ;AA1DI;EACE,0BAAA;AA4DN;;AAhEE;EACE,gCAAA;AAmEJ;AAjEI;EACE,0BAAA;AAmEN;;AAvEE;EACE,gCAAA;AA0EJ;AAxEI;EACE,0BAAA;AA0EN;;AA9EE;EACE,gCAAA;AAiFJ;AA/EI;EACE,0BAAA;AAiFN;;AArFE;EACE,gCAAA;AAwFJ;AAtFI;EACE,0BAAA;AAwFN;;AA5FE;EACE,gCAAA;AA+FJ;AA7FI;EACE,0BAAA;AA+FN;;AAnGE;EACE,gCAAA;AAsGJ;AApGI;EACE,0BAAA;AAsGN;;AA1GE;EACE,gCAAA;AA6GJ;AA3GI;EACE,0BAAA;AA6GN;;AAjHE;EACE,gCAAA;AAoHJ;AAlHI;EACE,0BAAA;AAoHN;;AAxHE;EACE,gCAAA;AA2HJ;AAzHI;EACE,0BAAA;AA2HN;;AA/HE;EACE,gCAAA;AAkIJ;AAhII;EACE,0BAAA;AAkIN;;AAtIE;EACE,gCAAA;AAyIJ;AAvII;EACE,0BAAA;AAyIN;;AA7IE;EACE,gCAAA;AAgJJ;AA9II;EACE,0BAAA;AAgJN;;AApJE;EACE,gCAAA;AAuJJ;AArJI;EACE,0BAAA;AAuJN;;AA3JE;EACE,gCAAA;AA8JJ;AA5JI;EACE,0BAAA;AA8JN;;AAlKE;EACE,gCAAA;AAqKJ;AAnKI;EACE,0BAAA;AAqKN;;AAzKE;EACE,gCAAA;AA4KJ;AA1KI;EACE,0BAAA;AA4KN;;AAhLE;EACE,gCAAA;AAmLJ;AAjLI;EACE,0BAAA;AAmLN;;AAvLE;EACE,gCAAA;AA0LJ;AAxLI;EACE,0BAAA;AA0LN;;AA9LE;EACE,gCAAA;AAiMJ;AA/LI;EACE,0BAAA;AAiMN;;AArME;EACE,gCAAA;AAwMJ;AAtMI;EACE,0BAAA;AAwMN;;AA5ME;EACE,gCAAA;AA+MJ;AA7MI;EACE,0BAAA;AA+MN;;AAnNE;EACE,gCAAA;AAsNJ;AApNI;EACE,0BAAA;AAsNN;;AA1NE;EACE,gCAAA;AA6NJ;AA3NI;EACE,0BAAA;AA6NN;;AAjOE;EACE,gCAAA;AAoOJ;AAlOI;EACE,0BAAA;AAoON;;AAxOE;EACE,gCAAA;AA2OJ;AAzOI;EACE,0BAAA;AA2ON;;AA/OE;EACE,gCAAA;AAkPJ;AAhPI;EACE,0BAAA;AAkPN;;AAtPE;EACE,gCAAA;AAyPJ;AAvPI;EACE,0BAAA;AAyPN;;AA7PE;EACE,gCAAA;AAgQJ;AA9PI;EACE,0BAAA;AAgQN;;AApQE;EACE,gCAAA;AAuQJ;AArQI;EACE,0BAAA;AAuQN;;AA3QE;EACE,gCAAA;AA8QJ;AA5QI;EACE,0BAAA;AA8QN;;AAlRE;EACE,gCAAA;AAqRJ;AAnRI;EACE,0BAAA;AAqRN;;AAzRE;EACE,gCAAA;AA4RJ;AA1RI;EACE,0BAAA;AA4RN;;AAhSE;EACE,gCAAA;AAmSJ;AAjSI;EACE,0BAAA;AAmSN;;AAvSE;EACE,gCAAA;AA0SJ;AAxSI;EACE,0BAAA;AA0SN;;AA9SE;EACE,gCAAA;AAiTJ;AA/SI;EACE,0BAAA;AAiTN;;AArTE;EACE,gCAAA;AAwTJ;AAtTI;EACE,0BAAA;AAwTN;;AA5TE;EACE,gCAAA;AA+TJ;AA7TI;EACE,0BAAA;AA+TN;;AAnUE;EACE,gCAAA;AAsUJ;AApUI;EACE,0BAAA;AAsUN;;AA1UE;EACE,gCAAA;AA6UJ;AA3UI;EACE,0BAAA;AA6UN;;AAjVE;EACE,gCAAA;AAoVJ;AAlVI;EACE,0BAAA;AAoVN;;AAxVE;EACE,gCAAA;AA2VJ;AAzVI;EACE,0BAAA;AA2VN;;AA/VE;EACE,gCAAA;AAkWJ;AAhWI;EACE,0BAAA;AAkWN;;AAtWE;EACE,gCAAA;AAyWJ;AAvWI;EACE,0BAAA;AAyWN;;AA7WE;EACE,gCAAA;AAgXJ;AA9WI;EACE,0BAAA;AAgXN;;AA9VI;EACE,iBAAA;AAiWN;AAvVI;EACE,iBAAA;AAyVN;AAtVI;EACE,iBAAA;AAwVN;;AAxWI;EACE,iBAAA;AA2WN;AAjWI;EACE,kBAAA;AAmWN;AAhWI;EACE,kBAAA;AAkWN;;AAlXI;EACE,iBAAA;AAqXN;AA3WI;EACE,kBAAA;AA6WN;AA1WI;EACE,kBAAA;AA4WN;;AA5XI;EACE,iBAAA;AA+XN;AArXI;EACE,kBAAA;AAuXN;AApXI;EACE,kBAAA;AAsXN;;AAtYI;EACE,iBAAA;AAyYN;AA/XI;EACE,kBAAA;AAiYN;AA9XI;EACE,kBAAA;AAgYN;;AAhZI;EACE,iBAAA;AAmZN;AAzYI;EACE,kBAAA;AA2YN;AAxYI;EACE,kBAAA;AA0YN;;AA1ZI;EACE,iBAAA;AA6ZN;AAnZI;EACE,kBAAA;AAqZN;AAlZI;EACE,kBAAA;AAoZN;;AApaI;EACE,iBAAA;AAuaN;AA7ZI;EACE,kBAAA;AA+ZN;AA5ZI;EACE,kBAAA;AA8ZN;;AA9aI;EACE,iBAAA;AAibN;AAvaI;EACE,kBAAA;AAyaN;AAtaI;EACE,kBAAA;AAwaN;;AAxbI;EACE,iBAAA;AA2bN;AAjbI;EACE,kBAAA;AAmbN;AAhbI;EACE,kBAAA;AAkbN;;AAlcI;EACE,iBAAA;AAqcN;AA3bI;EACE,mBAAA;AA6bN;AA1bI;EACE,mBAAA;AA4bN;;AA5cI;EACE,iBAAA;AA+cN;AArcI;EACE,mBAAA;AAucN;AApcI;EACE,mBAAA;AAscN;;AAtdI;EACE,iBAAA;AAydN;AA/cI;EACE,mBAAA;AAidN;AA9cI;EACE,mBAAA;AAgdN;;AAheI;EACE,iBAAA;AAmeN;AAzdI;EACE,mBAAA;AA2dN;AAxdI;EACE,mBAAA;AA0dN;;AA1eI;EACE,iBAAA;AA6eN;AAneI;EACE,mBAAA;AAqeN;AAleI;EACE,mBAAA;AAoeN;;AApfI;EACE,iBAAA;AAufN;AA7eI;EACE,mBAAA;AA+eN;AA5eI;EACE,mBAAA;AA8eN;;AA9fI;EACE,iBAAA;AAigBN;AAvfI;EACE,mBAAA;AAyfN;AAtfI;EACE,mBAAA;AAwfN;;AAxgBI;EACE,iBAAA;AA2gBN;AAjgBI;EACE,mBAAA;AAmgBN;AAhgBI;EACE,mBAAA;AAkgBN;;AAlhBI;EACE,iBAAA;AAqhBN;AA3gBI;EACE,mBAAA;AA6gBN;AA1gBI;EACE,mBAAA;AA4gBN;;AA5hBI;EACE,iBAAA;AA+hBN;AArhBI;EACE,mBAAA;AAuhBN;AAphBI;EACE,mBAAA;AAshBN;;AAtiBI;EACE,iBAAA;AAyiBN;AA/hBI;EACE,mBAAA;AAiiBN;AA9hBI;EACE,mBAAA;AAgiBN;;AAhjBI;EACE,iBAAA;AAmjBN;AAziBI;EACE,mBAAA;AA2iBN;AAxiBI;EACE,mBAAA;AA0iBN;;AA1jBI;EACE,iBAAA;AA6jBN;AAnjBI;EACE,mBAAA;AAqjBN;AAljBI;EACE,mBAAA;AAojBN;;AApkBI;EACE,iBAAA;AAukBN;AA7jBI;EACE,mBAAA;AA+jBN;AA5jBI;EACE,mBAAA;AA8jBN;;AA9kBI;EACE,iBAAA;AAilBN;AAvkBI;EACE,mBAAA;AAykBN;AAtkBI;EACE,mBAAA;AAwkBN;;AAxlBI;EACE,iBAAA;AA2lBN;AAjlBI;EACE,mBAAA;AAmlBN;AAhlBI;EACE,mBAAA;AAklBN;;AAlmBI;EACE,iBAAA;AAqmBN;AA3lBI;EACE,mBAAA;AA6lBN;AA1lBI;EACE,mBAAA;AA4lBN;;AA5mBI;EACE,iBAAA;AA+mBN;AArmBI;EACE,mBAAA;AAumBN;AApmBI;EACE,mBAAA;AAsmBN;;AAtnBI;EACE,iBAAA;AAynBN;AA/mBI;EACE,mBAAA;AAinBN;AA9mBI;EACE,mBAAA;AAgnBN;;AAhoBI;EACE,iBAAA;AAmoBN;AAznBI;EACE,mBAAA;AA2nBN;AAxnBI;EACE,mBAAA;AA0nBN;;AA1oBI;EACE,iBAAA;AA6oBN;AAnoBI;EACE,mBAAA;AAqoBN;AAloBI;EACE,mBAAA;AAooBN;;AAjnBA;EACE,gBAAA;AAonBF;;AAjnBA;EAEE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EAEA,YAAA;EAEA,sBAAA;EAEA;;;;;;;KAAA;EAQA,aAAA;AAgnBF;;AA5mBE;EACE,cAAA;AA+mBJ;;AA3mBA;EACE,gBAAA;EACA,SAAA;AA8mBF;AA5mBE;EACE,0BAAA;EACA,YAAA;AA8mBJ;;AA1mBA;EACE,wBAAA;AA6mBF;;AA1mBA;EACE,mBAAA;AA6mBF;;AA1mBA;EACE,6BAAA;EACA,cC3lBW;ED4lBX,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;AA6mBF;;AAxmBE;;EAEE,iBAAA;AA2mBJ;;AAvmBA;EACE,iBAAA;AA0mBF;;AAvmBA;EACE,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AA0mBF;;AAtmBE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AAymBJ;AAtmBE;EACE,0BAAA;EACA,iBAAA;AAwmBJ;AArmBE;EACE,gBAAA;AAumBJ;;AAnmBA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,0CAAA;AAsmBF;;AAnmBA;EACE,iBAAA;AAsmBF;;AAnmBA;EACE,iBAAA;AAsmBF;;AAnmBA;EACE,uBAAA;AAsmBF;;AAnmBA;EACE,0BAAA;EACA,4BAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,qBAAA;EACA,qBAAA;AAsmBF;;AAnmBA;;EAEE,8BAAA;EACA,gCAAA;EACA,sBAAA;AAsmBF;;AAnmBA;;EAEE,8BAAA;EACA,gCAAA;EACA,sBAAA;AAsmBF;;AAnmBA;;EAEE,8BAAA;EACA,gCAAA;EACA,sBAAA;AAsmBF;;AAnmBA;EACE,8BAAA;EACA,gCAAA;EACA,sBAAA;AAsmBF;;AAnmBA;EACE,sBAAA;AAsmBF;;AAnmBA;EACE,sBAAA;EACA,4BAAA;EACA,0BAAA;EACA,yBAAA;EACA,iBAAA;EACA,6BAAA;EACA,uDAAA;EACA,sIAAA;AAsmBF;AAlmBI;EACE,cAAA;AAomBN;;AA/lBA;EACE,kBAAA;EACA,wBAAA;EACA,sBAAA;AAkmBF;;AA/lBA;EACE,qCC1oBc;ED2oBd,gBAAA;AAkmBF;;AA/lBA;EACE,qCC/oBc;EDgpBd,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,0BAAA;AAkmBF;;AA/lBA;EACE,cAAA;AAkmBF;;AA/lBA;EACE,kBAAA;AAkmBF;;AA/lBA;EACE,gBAAA;AAkmBF;;AA/lBA;EACE,iBAAA;AAkmBF;;AA/lBA;EACE,cAAA;AAkmBF;;AA7lBI;EACE,mBAAA;AAgmBN;AA7lBI;EACE,gBAAA;EACA,qCAAA;AA+lBN;;AA1lBA;EACE,UAAA;EACA,gBAAA;AA6lBF;;AA1lBA;EACE,uBAAA;EACA,0BAAA;EACA,qBAAA;EACA,wBAAA;EACA,2BAAA;AA6lBF;;AA1lBA;EACE,eAAA;AA6lBF;;AA1lBA;EACE,aAAA;AA6lBF;;AA1lBA;EACE,aAAA;AA6lBF;;AA1lBA;EACE,kBAAA;AA6lBF;;AA1lBA;EACE,yCAAA;EACA,0BAAA;AA6lBF;;AA1lBA;EACE,eAAA;EACA,UAAA;AA6lBF;;AA1lBA;;EAEE,cAAA;AA6lBF;;AA1lBA;;;EAGE,kBAAA;AA6lBF;;AA1lBA;;EAEE,oBAAA;AA6lBF;;AA1lBA;EACE,kBAAA;AA6lBF;;AA1lBA;EACE,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AA6lBF;;AA1lBA;;EAIE,gBAAA;EACA,6BAAA;AA2lBF;;AAxlBA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;AA2lBF;;AAtlBE;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;AAylBJ;;AArlBA;EACE,YAAA;EACA,2HAAA;AAwlBF;AArlBE;;EAEE,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAulBJ;AAplBE;EACE,mBAAA;AAslBJ;;AAllBA;EACE,0BAAA;EACA,YAAA;AAqlBF;AAplBE;EACE,YAAA;AAslBJ;;AAllBA;;EAEE,oBAAA;EACA,mBAAA;EACA,mBAAA;AAqlBF;;AAllBA;;EAEE,cAAA;AAqlBF;;AAllBA;EACE,sBAAA;EACA,cAAA;EACA,6BAAA;AAqlBF;;AAllBA;EACE,iBAAA;EACA,qBAAA;EACA,eAAA;AAqlBF;;AAllBA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AAqlBF;;AAllBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AAqlBF;;AAllBA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AAqlBF;;AAllBA;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AAqlBF;;AAllBA;EACE,kBAAA;EACA,kBAAA;AAqlBF;;AAllBA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAqlBF;;AAllBA;EACE,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AAqlBF;;AAllBA;EACE,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;AAqlBF;;AAllBA;EACE,eAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAqlBF;;AAllBA;EACE,eAAA;AAqlBF;;AAllBA;EACE,WAAA;EACA,YAAA;AAqlBF;;AAllBA;EACE,aAAA;EACA,eAAA;EACA,cAAA;AAqlBF;;AAllBA;EACE,kBAAA;AAqlBF;;AAllBA;EACE,iBAAA;EACA,iBAAA;AAqlBF;;AAllBA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AAqlBF;;AAllBA;EACE,qEAAA;AAqlBF;AApkBA;EACE,gBAAA;EACA,kBAAA;AAklBF;;AA/kBA;EACE,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,+DAAA;EACA,4BAAA;EACA,iFAAA;AAklBF;;AA5kBA;EACE;;;;;GAAA;EAMA,aAAA;AA+kBF;AA7kBE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AA+kBJ;AA7kBI;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;AA+kBN;AA7kBM;EACE,eAAA;AA+kBR;AA7kBQ;EACE,qCAAA;AA+kBV;AA1kBI;EACE,mBAAA;AA4kBN;AAzkBI;EACE,wBAAA;AA2kBN;AAxkBI;EACE,WAAA;EACA,iBAAA;EACA,+CAAA;EACA,aAAA;AA0kBN;AArkBI;EACE,yBAAA;AAukBN;AAnkBE;EACE,SAAA;AAqkBJ;AAlkBE;EACE,0BAAA;AAokBJ;;AAhkBA;EACE,SAAA;EACA,UAAA;AAmkBF;AAjkBE;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;AAmkBJ;AAjkBI;EACE,cAAA;AAmkBN;AAhkBI;EACE,iBAAA;EACA,yBAAA;AAkkBN;AA9jBM;EACE,oBAAA;AAgkBR;AA3jBE;EACE,eAAA;AA6jBJ;;AAzjBA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AA4jBF;AA1jBE;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AA4jBJ;AAzjBE;EACE,2BAAA;AA2jBJ;;AAtjBA;EACE,UAAA;AAyjBF;;AAtjBA;EACE,eAAA;AAyjBF;;AAtjBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;AAyjBF;;AAtjBA;EACE,gBAAA;AAyjBF;;AAtjBA;EACE,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AAyjBF;;AArjBA;EACE;IACE,4BAAA;EAwjBF;EArjBA;IACE,2BAAA;EAujBF;EApjBA;IACE,2BAAA;EAsjBF;AACF;AAnjBA;EACE,qEAAA;AAqjBF;;AAljBA;EACE;IACE,UAAA;EAqjBF;EAljBA;IACE,YAAA;EAojBF;EAjjBA;IACE,UAAA;EAmjBF;AACF;AAhjBA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eClpCa;ADosDf;AAhjBE;EACE,sBAAA;EACA,iBAAA;AAkjBJ;;AA9iBA;EACE,gBAAA;EACA,iBAAA;AAijBF;;AA9iBA;EACE,kBAAA;AAijBF;AA/iBE;EACE,YAAA;AAijBJ;;AA5iBE;EACE,aAAA;AA+iBJ;AA7iBI;EACE,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AA+iBN;AA5iBI;EACE,kBAAA;EACA,8BCzqCW;ED0qCX,mBAAA;EACA,aAAA;AA8iBN;AA5iBM;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AA8iBR;AAxiBI;EACE,QAAA;AA0iBN;AAviBI;EACE,QAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AAyiBN;;AApiBA;EACE,aAAA;AAuiBF;;AApiBA;EACE,yBAAA;AAuiBF;;AApiBA;EACE,4BAAA;AAuiBF;;AApiBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAuiBF;AAriBE;EACE,kBAAA;AAuiBJ;AApiBE;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAsiBJ;AAniBE;EACE,WAAA;EACA,YAAA;AAqiBJ;AAliBE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AAoiBJ;AAjiBE;EACE,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAmiBJ;AAjiBE;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAmiBJ;AAhiBE;EACE,eAAA;EACA,wBAAA;AAkiBJ;AAhiBI;EACE,iBAAA;AAkiBN;AA/hBI;EACE,iBAAA;AAiiBN;AA/hBM;EACE,WAAA;EACA,YAAA;AAiiBR;;AA3hBA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;AA8hBF;;AA1hBE;EACE,cAAA;EACA,gBAAA;AA6hBJ;AA1hBE;EACE,gBAAA;EACA,gBAAA;AA4hBJ;AAzhBE;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AA2hBJ;AAzhBE;EACE,QAAA;EACA,SAAA;AA2hBJ;AAxhBE;;EAEE,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AA0hBJ;AAxhBI;;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AA2hBN;AAxhBI;;EACE,eAAA;AA2hBN;AAxhBI;;EACE,mBAAA;AA2hBN;AAxhBI;;EACE,mBAAA;AA2hBN;AAxhBI;;EACE,mBAAA;AA2hBN;AAxhBI;;EACE,mBAAA;AA2hBN;AAvhBE;EACE,eAAA;EACA,SAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAyhBJ;AAxhBI;EACE,gBAAA;EACA,eAAA;EACA,eAAA;AA0hBN;AAvhBI;EACE,eAAA;EACA,aAAA;AAyhBN;AAlmBA;EA4EE;;;;;;;;;;;;;;;;;;;;KAAA;AA6iBF;;AAthBA;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AAyhBF;;AAthBA;EACE,8BAAA;AAyhBF;;AAthBA;EACE,sBAAA;AAyhBF;;AAthBA;EACE,YAAA;EACA,WAAA;EACA,sBAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;AAyhBF;;AAthBA;EACE,sBAAA;EACA,UAAA;EACA;;KAAA;AA2hBF;;AAthBA;;GAAA;AAGA;;EAEE,WAAA;EACA,kBAAA;AAyhBF;;AAthBA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,yCAAA;EACA,0CAAA;AAyhBF;AAvhBE;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2CAAA;EACA,4CAAA;AAyhBJ;AAthBE;EACE,eAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAwhBJ;AArhBE;EACE,+BAAA;AAuhBJ;AAphBE;EACE,8BAAA;AAshBJ;;AAlhBA;EACE,YAAA;EACA,mBAAA;AAqhBF;;AAlhBA;EACE,WAAA;EACA,WAAA;AAqhBF;;AAlhBA;EACE,iBAAA;EACA,SAAA;EACA,cAAA;AAqhBF;;AAlhBA;EACE,iBAAA;EACA,gBAAA;AAqhBF;;AAlhBA;EACE,gBAAA;AAqhBF;;AAlhBA;EACE,wBAAA;EACA,+BAAA;AAqhBF;;AAlhBA;EACE,gBAAA;EACA,+BAAA;AAqhBF;;AAlhBA;EACE,WAAA;EACA,+BAAA;AAqhBF;;AAlhBA;EACE,gBAAA;EACA,+BAAA;AAqhBF;;AAlhBA;EACE,aAAA;AAqhBF;;AAlhBA;EACE,qBAAA;EACA,kBAAA;AAqhBF;;AAlhBA;EACE,UAAA;AAqhBF;;AAlhBA;EACE,oBAAA;AAqhBF;;AAlhBA;EACE,eAAA;AAqhBF;;AAjhBA;EACE,aAAA;AAohBF;AAlhBE;EACE,gBAAA;AAohBJ;;AA1gBA;EACE,aAAA;EACA,kBAAA;AA6gBF;AA3gBE;EACE,eAAA;EACA,gBAAA;AA6gBJ;AA1gBE;EACE,eAAA;EACA,kBAAA;AA4gBJ;AAzgBE;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;AA2gBJ;AAxgBE;EACE,+BAAA;AA0gBJ;AAvgBE;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AAygBJ;AAtgBE;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AAwgBJ;AArgBE;EACE,gBAAA;EACA,kBAAA;AAugBJ;AArgBI;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;AAugBN;AAngBE;EACE,oBAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;AAqgBJ;AAlgBE;EACE,eAAA;EACA,iBAAA;AAogBJ;AAjgBE;EACE,kBAAA;AAmgBJ;AAjgBI;EACE,cAAA;EACA,aAAA;AAmgBN;AAhgBI;EACE,WAAA;AAkgBN;AA9fE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AAggBJ;;AA3fA;EACE,kBAAA;EACA,eAAA;EAEA,WAAA;EACA,QAAA;EACA,0BAAA;EACA,eAAA;AA6fF;;AAvfA;;;EAGE,eAAA;EACA,YC/sDa;EDgtDb,SC7sDO;ED8sDP,WAAA;EACA,YCxtDc;EDytDd,yHAAA;EACA,gBAAA;AA0fF;;AAvfA;;EAEE,WC/tDc;ADytEhB;;AAvfA;EACE,iBAAA;EACA,gBAAA;EACA,qCCzpDc;ED0pDd,eAAA;EACA,iBAAA;AA0fF;AAxfE;EACE,mBAAA;EACA,kBAAA;AA0fJ;AAvfE;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;AAyfJ;AAvfI;EACE,eCzrDS;ED0rDT,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BCjrDW;EDkrDX,QAAA;AAyfN;;AApfA;EACE,wCAAA;AAufF;;AApfA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAufF;AArfE;EACE,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AAsfJ;AApfI;EACE,WAAA;EACA,YAAA;AAsfN;AAnfI;EACE,cAAA;EAEA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AAofN;AAjfI;EACE,eCzuDS;ED0uDT,SAAA;EACA,gBAAA;AAmfN;AA/eE;EACE,gBAAA;EAEA,eAAA;EACA,cAAA;EACA,gBAAA;AAgfJ;AA5hBA;EAiDE;;;;;;KAAA;AAofF;AA7eE;EACE,SAAA;EACA,UAAA;AA+eJ;;AA1eA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AA6eF;;AAxeA;EACE,kBAAA;EACA,gBAAA;AA2eF;AAzeE;EACE,qCCtwDY;EDuwDZ,aAAA;EACA,8BAAA;EACA,mBAAA;AA2eJ;;AAveA,gCAAA;AACA;;EAEE,YAAA;AA0eF;;AAveA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,gBAAA;AA0eF;;AAveA;EACE,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;AA0eF;AAxeE;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA0eJ;AAveE;EACE,WAAA;EACA,YAAA;AAyeJ;;AAreA;EACE,eAAA;EACA,YAAA;AAweF;AAteE;EACE,+BAAA;AAweJ;AAreE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAueJ;;AAneA;EACE,YAAA;AAseF;;AAneA;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,2CAAA;AAseF;;AAleE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAqeJ;AAleE;EACE,mBAAA;AAoeJ;;AAheA;EACE,aAAA;EACA,SAAA;AAmeF;;AAheA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;AAmeF;AAjeE;EACE,WAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;AAmeJ;;AA7dA;EAEE;;IAEE,aAAA;EA+dF;EA5dA;IACE,MAAA;EA8dF;AACF;AA1dA;EACE;IACE,aAAA;IACA,gBAAA;EA4dF;EA1dA;IACE,eAAA;IACA,UAAA;EA4dF;EA1dA;IAAyB,eAAA;EA6dzB;EA5dA;IACE,0BAAA;EA8dF;EA3dA;IACE,WAAA;IACA,WAAA;EA6dF;EA1dA;IACE,cAAA;EA4dF;EAzdA;IACE,MAAA;IACA,eAAA;EA2dF;EAzdA;IACE,iBAAA;EA2dF;AACF;AAxdA;EACE;IACE,wBAAA;EA0dF;AACF;AAhdA;EACE;IACE,kBAAA;EAkdF;AACF;AA/cA;EACE,mBAAA;EACA,yBAAA;AAidF;AAhdE;EACE,cAAA;AAkdJ;AAhdE;;EAEE,YAAA;AAkdJ;AA/cE;;EAEE,cAAA;EACA,kBAAA;EACA,gBAAA;AAidJ;AA9cE;EACE,iBAAA;EACA,gBAAA;EACA,uBAAA;AAgdJ;AA7cE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AA+cJ;AA3cI;EACE,iBAAA;EACA,mBAAA;AA6cN;AA5cM;EACE,qBAAA;AA8cR;AAzcE;EACE,mBAAA;AA2cJ;AAxcE;EACE,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,oBAAA;AA0cJ;;AArcE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,kBAAA;AAwcJ;AAtcI;EACE,+BAAA;AAwcN;AApcE;;;EAGE,cAAA;AAscJ;AAncE;EACE,YAAA;AAqcJ;AAlcE;EACE,gBAAA;AAocJ;AAjcE;EACE,YAAA;EACA,eAAA;AAmcJ;;AA9bA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,qCAAA;EACA,iBAAA;EACA,kBAAA;AAicF;AA/bE;EACE,iBAAA;AAicJ;;AA7bA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;AAgcF;AA9bE;EACE,kDAAA;EACA,kDAAA;EACA,gBAAA;AAgcJ;;AA5bA;EACE,6BAAA;AA+bF;;AA5bA;EACE,oCAAA;EACA,iBAAA;AA+bF;;AA5bA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AA+bF;AA7bE;EACE,gBAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;AA+bJ;AA5bE;EACE,aAAA;EACA,eAAA;AA8bJ;;AA1bA;EACE,cAAA;EACA,mDAAA;EACA,8BAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,UAAA;AA6bF;AA3bE;EACE,gBAAA;AA6bJ;;AAzbA;EAEE;IAGE,UAAA;EAybF;EAtbA;IACE,UAAA;EAwbF;AACF;AArbA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;AAubF;AArbE;EACE,iBAAA;AAubJ;;AAnbA;EACE,UAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;AAsbF;AApbE;EACE,oBAAA;EACA,mBAAA;AAsbJ;;AAlbA;EACE,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AAqbF;AApbE;EACE,mBAAA;AAsbJ;;AAjbE;;EACE,aAAA;AAqbJ;;AAjbA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;AAobF;AAnbE;EACE,cAAA;EACA,kBAAA;EACA,cAAA;AAqbJ;AApbI;EACE,qBAAA;EACA,wBAAA;AAsbN;;AAlbA;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;AAqbF;AApbE;EACE,kBAAA;AAsbJ;;AAnbA;EACE,yBAAA;AAsbF;;AApbA;EACE,yBAAA;AAubF;;AArbA;EACE,yBAAA;AAwbF;;AAtbA;EACE,yBAAA;AAybF;;AAvbA;EACE,yBAAA;AA0bF;;AAxbA;EACE,yBAAA;AA2bF;;AAxbE;EACE,iBAAA;EACA,cAAA;AA2bJ;AAzbE;EACE,iBAAA;EACA,cAAA;AA2bJ;AAzbE;EACE,iBAAA;EACA,cAAA;AA2bJ;AAzbE;EACE,iBAAA;EACA,cAAA;AA2bJ;;AAvbE;EACE,eAAA;AA0bJ;AAxbE;EACE,eAAA;EACA,iBAAA;AA0bJ;AAxbE;EACE,kBAAA;AA0bJ;;AAtbA;EACE,sBAAA;AAybF;;AAvbA;EACE,sBAAA;AA0bF;AAzbE;EACE,WAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AA2bJ;;AAvbA;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;AA0bF;;AAvbA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;AA0bF;AAzbE;EACE,cAAA;AA2bJ;AAzbE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA2bJ;AAzbE;EACE,eAAA;AA2bJ;AAzbE;EACE,eAAA;EACA,eAAA;AA2bJ;;AAxbA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,oBAAA;EACA,kDAAA;AA2bF;AA1bE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;AA4bJ;AA3bI;EACE,6BAAA;AA6bN;AA1bE;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA4bJ;AA1bE;EACE,eAAA;EACA,gBAAA;AA4bJ;;AAxbA;EACE,aAAA;EACA,iCAAA;AA2bF;;AAxbA;EACE,aAAA;AA2bF;;AAtbA;EACE,iBAAA;EACA,sBAAA;EACA,WAAA;EACA,2BAAA;EACA,kBAAA;EACA,cAAA;AAybF;AAxbE;EACE,4BAAA;EACA,6BAAA;AA0bJ;AAxbE;EACE,WAAA;EACA,WAAA;AA0bJ;AAxbE;EACE,WAAA;EACA,YAAA;AA0bJ;AAxbE;;EAEE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AA0bJ;AAxbE;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AA0bJ;AAxbE;EACE,eAAA;EACA,mBAAA;AA0bJ;;AAtbA;EAAyC,cAAA;AA0bzC;;AAxbA;EACE,mBAAA;AA2bF;;AAxbA;EACE,UAAA;AA2bF","sourcesContent":["// =====================================================\n// =====================================================\n// =====================================================\n//                      BASE\n// =====================================================\n// =====================================================\n// =====================================================\n@import './variables';\n/* @import \"./components/reboot\";\n@import \"./components/grid\";\n@import \"./components/type\";\n@import \"./components/buttons\";\n@import \"./components/forms\";\n@import \"./components/input-group\";\n@import \"./components/text\";\n@import \"./components/custom-forms\"; */\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n* {\n  box-sizing: border-box;\n}\n\n.material-icons {\n  box-sizing: initial;\n}\n\nhtml {\n  font-size: 14px;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: $baseFontFamily;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  // background: url('/assets/images/main-bg.png');\n}\n\n.sidebar-icon-gap {\n  padding-left: 38px !important;\n}\n\n.ff-1 {\n  font-family: 'Poppins', sans-serif !important;\n}\n\n.ff-2 {\n  font-family: 'PT Sans', sans-serif !important;\n}\n\n.ff-3 {\n  font-family: 'Raleway', sans-serif !important;\n}\n\n.ff-4 {\n  font-family: 'Roboto', sans-serif !important;\n}\n\n.ff-5 {\n  font-family: 'Nunito', sans-serif !important;\n}\n\n.hover {\n  cursor: pointer;\n}\n.reminder-cost small {\n  font-style: italic;\n  font-size: $baseFontSize;\n  font-weight: normal;\n}\n.mainten-section {\n  padding: 10px;\n  margin-bottom: 10px;\n  font-size: 12px;\n  // &.mainten-overdue {\n  //   border-left: 4px solid #d32f2f;\n  // }\n  // &.mainten-scheduled {\n  //   border-left: 4px solid #1879EB;\n  // }\n  // &.mainten-due {\n  //   border-left: 4px solid #F69B24;\n  // }\n  .text-overdue {\n    color: #d32f2f;\n  }\n  .text-scheduled {\n    color: #1879EB;\n  }\n  .text-due {\n    color: #F69B24;\n  }\n  .toggle-section-button {\n    margin-left: 10px;\n    vertical-align: middle;\n  }\n  .mainten-column-section {\n    display: flex;\n    padding-bottom: 6px;\n    margin-bottom: 6px;\n    > div {\n      flex: 1\n    }\n  }\n  .mainten-section-header {\n    display: flex;\n    justify-content: space-between;\n    border-bottom-width: 2px;\n    border-bottom-style: dashed;\n    padding-bottom: 6px;\n    margin-bottom: 6px;\n  }\n  .mainten-highlight-section,\n  .mainten-split-section {\n    display: flex;\n    justify-content: space-between;\n    gap: 20px;\n    align-items: center;\n    > div:first-child {\n      border-right-width: 2px;\n      border-right-style: dashed;\n      padding-right: 20px;\n    }\n    > div {\n      flex: 1;\n    }\n    // margin-bottom: 6px;\n  }\n  .mainten-highlight-section {\n    padding: 10px;\n    > div {\n      text-align: center;\n    }\n  }\n  .mainten-section-footer {\n    border-top-width: 2px;\n    border-top-style: dashed;\n    display: flex;\n    gap: 6px;\n    padding-top: 10px;\n    justify-content: flex-end;\n    text-align: right;\n    .theme-button {\n      margin-bottom: 6px;\n    }\n    .theme-button ~ .theme-button {\n      margin-left: 6px;\n    }\n  }\n}\n.reminder-section {\n  border: 2px dashed;\n  padding: 10px;\n  margin-bottom: 10px;\n  font-size: 12px;\n  label {\n    display: block;\n  }\n  .reminder-section-header {\n    display: flex;\n    justify-content: space-between;\n    border-bottom-width: 2px;\n    border-bottom-style: dashed;\n    padding-bottom: 6px;\n    margin-bottom: 6px;\n    align-items: center;\n  }\n  .reminder-section-footer {\n    display: flex;\n    gap: 6px;\n    justify-content: flex-end;\n    text-align: right;\n    .theme-button {\n      margin-bottom: 6px;\n    }\n    .theme-button ~ .theme-button {\n      margin-left: 6px;\n    }\n  }\n  .reminder-section-body {\n    display: flex;\n    gap: 20px;\n    margin-bottom: 12px;\n  }\n}\n\n\n.leaflet-container {\n  font-family: inherit;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\na {\n  //color: $themeColor;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n.list-unstyled {\n  list-style: none;\n}\n\n.badge {\n  display: inline-block;\n  width: 1.2em;\n  height: 1.2em;\n  line-height: 1.2em;\n  color: $badgeColor;\n  font-size: $baseFontSize;\n  background: $badgeBgColor;\n  text-align: center;\n  border-radius: 50%;\n}\n\n.text-theme {\n  color: $themeColor;\n}\n\n.clearfix {\n\n  &:before,\n  &:after {\n    display: table;\n    content: ' ';\n    clear: both;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.text-normal {\n  font-size: $baseFontSize;\n}\n\n.v-hidden {\n  visibility: hidden;\n}\n\n.form-check-label label,\n.form-check-label {\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  margin: 0;\n}\n\n.checkbox {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  margin: 0;\n  //color: #999;\n\n  input {\n    display: none;\n  }\n\n  .form-check-inline & input+span {\n    margin-right: 5px;\n  }\n\n  input+span {\n    vertical-align: top;\n    font-size: 14px;\n    display: flex;\n\n    span {\n      height: auto;\n      line-height: inherit;\n    }\n\n    .on-active {\n      display: none;\n    }\n  }\n\n  input:checked {\n    +span .on-active {\n      display: inline-block;\n      svg { display: block; }\n    }\n\n    +span .on-inactive {\n      display: none;\n    }\n  }\n}\n\n// sub menu\n.has-menu {\n  position: relative;\n\n  .has-menu>a:after {\n    content: 'keyboard_arrow_right';\n    display: block;\n    position: absolute;\n    right: 0;\n    top: 0;\n    font-family: 'Material Icons';\n    font-size: 20px;\n  }\n}\n\n.horizontal-menu ul {\n  white-space: nowrap;\n}\n\n.horizontal-menu li {\n  display: inline-block;\n  height: auto;\n}\n\n.sub-menu {\n  position: absolute;\n  top: 100%;\n  background: $dropdown-bg;\n  border-top: 3px solid $hoverBorderColor;\n  margin: 0;\n  margin-top: -3px;\n  padding: 0;\n  list-style: none;\n  min-width: 180px;\n  left: 0;\n  display: none;\n  text-align: left;\n  line-height: 1.4;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);\n  z-index: 9;\n\n  li a {\n    font-size: 12px;\n    color: $textColor;\n    text-decoration: none;\n    display: block;\n\n    &:hover {\n      .rel-icons {\n        color: inherit;\n      }\n    }\n  }\n\n  label span,\n  a span {\n    vertical-align: middle;\n    display: inline-block;\n  }\n\n  .unit-name {\n    min-width: inherit;\n    line-height: inherit;\n    margin-left: 0;\n  }\n\n  &.right-menu {\n    left: auto;\n    right: 0;\n  }\n\n  &.level-right {\n    top: 0;\n    left: 100%;\n  }\n\n  &.level-left {\n    top: 0;\n    right: 100%;\n    left: auto;\n  }\n\n  &.left-top {\n    bottom: 100%;\n    top: auto;\n  }\n\n  &.right-top {\n    bottom: 100%;\n    top: auto;\n    right: 0;\n    left: auto;\n  }\n\n  a {\n    padding: 6px 9px;\n  }\n\n  label {\n    display: block;\n    margin: 0;\n\n    input {\n      vertical-align: middle;\n      margin-right: 5px;\n    }\n  }\n\n  .rel-icons {\n    margin-right: 5px;\n    color: #aaa;\n  }\n}\n\n:hover>.sub-menu {\n  display: block;\n}\n\n.divider {\n  border-top: 1px solid $dropdown-border;\n}\n\n.sub-menu label:hover,\n.sub-menu .active a,\n.sub-menu a:hover {\n  background: $subMenuHoverBg;\n  color: $subMenuHoverColor;\n}\n\n.center-menu {\n  left: 50%;\n  width: 340px;\n  margin-left: -340 / 2 * 1px;\n}\n\n.marker {\n  transition: transform 0.4s linear;\n}\n\n.leaflet-tooltip.has-animation {\n  transition: transform 0.4s linear;\n\n  img {\n    transition: all 0.4s linear;\n  }\n}\n\n.color-inherit {\n  color: inherit !important;\n}\n\n.geoList {\n  list-style: none;\n  margin: 6px 0 0;\n  padding: 0;\n\n  .list-row {\n    margin-bottom: 6px;\n    border-radius: 5px;\n    padding-left: 6px;\n    box-sizing: border-box;\n  }\n\n  .list-row-1 {\n    margin-bottom: 6px;\n    border-radius: 5px;\n    padding-left: 6px;\n    width: 99%;\n    box-sizing: border-box;\n  }\n}\n\n.geofences-columns-wise {\n  .geoList {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    /* .list-row-1 {\n       width: 49%;\n    } */\n  }\n}\n\n/* .custom-tabs .Mui-disabled {\n  display: none;\n}\n */\n@for $i from 1 through 60 {\n  .seconds_#{$i} {\n    transition: transform $i * 1s linear;\n\n    img {\n      transition: all $i * 1s linear;\n    }\n  }\n}\n\n@for $i from 0 through 30 {\n  .scroll-width-#{$i} {\n\n    // .left-nav {\n    //   .nav {\n    //     margin-right: -$i * 1px;\n    //     box-sizing: content-box;\n    //     overflow: scroll;\n    //     position: relative;\n    //     bottom: -$i * 1px;\n    //     padding-bottom: $i * 1px;\n    //   }\n    // }\n    .notification-page-wrapper {\n      padding-top: ($i * 1px) + 10px;\n    }\n\n    // .custom-tabs-root {\n    //  margin-top: -$i * 1px;\n    // }\n    // .custom-tabs-scrollable {\n    //   position: relative;\n    //   bottom: -$i * 1px;\n    // }\n    .geofence-modal-form-inner {\n      margin-right: -$i * 1px;\n    }\n\n    .notification-scroller {\n      margin-right: -$i * 1px;\n    }\n  }\n}\n\n//@for $i from 1 through 30 {\n//  .scroll-width-#{$i} #scrollableDiv1,\n//  .scroll-width-#{$i} #scrollableDiv2,\n//  .scroll-width-#{$i} #scrollableDiv4,\n//  .scroll-width-#{$i} #scrollableDiv{\n//    margin-right: -$i * 1px;\n//    margin-bottom: -$i * 1px;\n//    padding-bottom: $i * 1px;\n//    //padding-right: $i * 1px;\n\n//    box-sizing: content-box;\n//  }\n//}\n\n.ref-marker {\n  background: none;\n}\n\n.pos-name {\n  //text-align: center;\n  position: absolute;\n  width: 320px;\n  left: 50%;\n  margin-left: -160px;\n  //white-space: nowrap;\n  bottom: 100%;\n  //letter-spacing: 1px;\n  box-sizing: border-box;\n\n  /* span {\n    font-size: 12px;\n    background: #fff;\n    border-radius: 3px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);\n    padding: 6px;\n    display: inline-block;\n  } */\n  display: none;\n}\n\n.marker:hover {\n  .pos-name {\n    display: block;\n  }\n}\n\n.custom-marker.leaflet-marker-icon {\n  background: none;\n  border: 0;\n\n  img {\n    max-width: 100% !important;\n    height: auto;\n  }\n}\n\n.hide-delete-btn .leaflet-draw-actions-bottom {\n  display: none !important;\n}\n\n.form-group {\n  margin-bottom: 25px;\n}\n\n.hilight {\n  border: 1px solid $borderColor;\n  color: $themeColor;\n  background: #fff;\n  padding: 6px;\n  display: inline-block;\n  border-radius: 4px;\n  margin: 6px 0;\n}\n\n.inline-buttons {\n\n  .theme-button,\n  button {\n    margin-right: 8px;\n  }\n}\n\n.ml-auto {\n  margin-left: auto;\n}\n\n.page-subtitle-notification {\n  font-weight: normal;\n  margin: 0;\n  padding: 0 0 4px;\n  font-size: 14px;\n}\n\n.report-sidebar-switch {\n  &:after {\n    content: '';\n    display: block;\n    height: 1px;\n    background: #fff;\n    margin: 10px auto;\n  }\n\n  .theme-button {\n    min-width: 70px !important;\n    margin: 0 4px 0 0;\n  }\n\n  &~&:after {\n    margin-bottom: 0;\n  }\n}\n\n.clearAllNotifcations {\n  position: absolute;\n  z-index: 999;\n  background: #f7f7f7;\n  border: 0;\n  width: 100%;\n  padding: 10px 30px;\n  font-size: 16px;\n  right: 10px;\n  max-width: 300px;\n  top: $headerHeight + 15px + 90px;\n  cursor: pointer;\n  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.2);\n}\n\n.notifications-tr {\n  margin-top: 143px;\n}\n\n.shown-clearall-btn .notifications-tr {\n  margin-top: 195px;\n}\n\n.notification-visible {\n  height: auto !important;\n}\n\n.notification-dismiss {\n  font-size: 22px !important;\n  line-height: 22px !important;\n  width: 22px !important;\n  height: 22px !important;\n  background: none !important;\n  top: 6.5px !important;\n  right: 7px !important;\n}\n\n.progress-green,\n.notification-success {\n  background: #43a047 !important;\n  border-color: #43a047 !important;\n  color: #fff !important;\n}\n\n.progress-yellow,\n.notification-warning {\n  background: #ffa000 !important;\n  border-color: #ffa000 !important;\n  color: #fff !important;\n}\n\n.progress-red,\n.notification-error {\n  background: #d32f2f !important;\n  border-color: #d32f2f !important;\n  color: #fff !important;\n}\n\n.notification-info {\n  background: #1976d2 !important;\n  border-color: #1976d2 !important;\n  color: #fff !important;\n}\n\n.notification-title {\n  color: #fff !important;\n}\n\n.notification-visible {\n  color: #fff !important;\n  padding: 8px 16px !important;\n  font-size: 14px !important;\n  letter-spacing: 0.01071em;\n  line-height: 1.43;\n  border-radius: 4px !important;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),\n    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12) !important;\n\n  &:hover {\n    .notification-dismiss {\n      display: block;\n    }\n  }\n}\n\n.notification-inner-box {\n  border-radius: 4px;\n  margin: -10px -16px -8px;\n  padding: 10px 16px 8px;\n}\n\n.alt-title {\n  font-family: $altFontFamily;\n  font-weight: 500;\n}\n\n.tab-title {\n  font-family: $altFontFamily;\n  font-weight: normal;\n  font-size: 24px;\n  padding: 16px 0 5px;\n  margin: 0;\n  border-radius: 6px 6px 0 0;\n}\n\n.text-danger {\n  color: #d32f2f;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-default {\n  color: inherit;\n}\n\n.table-fields-list {\n  .smooth-dnd-draggable-wrapper {\n    &:nth-child(Odd) {\n      background: #fafafa;\n    }\n\n    .selected_item {\n      background: none;\n      border: 1px solid rgba(0, 0, 0, 0.15);\n    }\n  }\n}\n\n.main-menu-list-wrapper ul {\n  padding: 0;\n  overflow: hidden;\n}\n\n.theme-input-select {\n  height: 36px !important;\n  font-size: 12px !important;\n  padding: 0 !important;\n  display: flex !important;\n  border-radius: 0 !important;\n}\n\n.theme-label {\n  font-size: 14px;\n}\n\n.theme-label-shrink {\n  margin-top: 0;\n}\n\n.theme-label-focused {\n  margin-top: 0;\n}\n\n.selector-list li {\n  margin-bottom: 6px;\n}\n\n.MuiTab-root {\n  font-family: $baseFontFamily !important;\n  font-size: $baseFontSize !important;\n}\n\n.theme-textarea {\n  font-size: 14px;\n  padding: 0;\n}\n\n.rv-xy-plot,\n.theme-cssOutlinedInput {\n  color: inherit;\n}\n\n.rv-xy-plot__axis text,\n.alt-x-label text,\n.alt-y-label text {\n  fill: currentColor;\n}\n\n.rv-xy-plot__axis line,\n.rv-xy-plot__grid-lines line {\n  stroke: currentColor;\n}\n\n.main-content-page-inner {\n  padding: 20px 26px;\n}\n\n.v-checkbox {\n  display: inline-block;\n  width: 18px !important;\n  height: 18px !important;\n  text-align: center;\n  border: 1px solid;\n  border-radius: 3px;\n}\n\n.MuiOutlinedInput-notchedOutline,\n.theme-notchedOutline {\n  // box-shadow: 0px 2px 4px 0px rgba(20, 20, 20, 0.15),\n  //   0px 2px 4px 0px rgba(20, 20, 20, 0.15) inset;\n  box-shadow: none;\n  border-radius: 4px !important;\n}\n\n.button-small {\n  min-height: 28px;\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\n.tab-container-outer {\n  \n  .custom-tabs-root {\n    margin-left: -15px;\n    margin-right: -15px;\n    margin-top: 4px;\n  }\n}\n\n.button-with-icon {\n  width: 110px;\n  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),\n    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);\n\n  span,\n  svg {\n    font-weight: normal;\n    font-size: 14px;\n    line-height: normal;\n    text-transform: none;\n    white-space: normal;\n    display: block;\n    text-align: center;\n  }\n\n  svg {\n    margin: 0 auto 10px;\n  }\n}\n\n.driver-page-content {\n  border-radius: 6px 0 0 6px;\n  height: 100%;\n  .page-title-inverse {\n    width: 260px;\n  }\n}\n\n.show-tracks,\n.show-points {\n  display: inline-flex;\n  align-items: center;\n  padding: 0 10px 0 0;\n}\n\nspan.form-control-label,\n.form-control-label {\n  color: inherit;\n}\n\n.material-icons {\n  vertical-align: middle;\n  color: inherit;\n  font-family: 'Material Icons';\n}\n\n.row-value {\n  font-weight: bold;\n  display: inline-block;\n  font-size: 14px;\n}\n\n.row-label {\n  font-size: 12px;\n  font-weight: normal;\n  min-width: 175px;\n  display: inline-block;\n}\n\n.license-card-img {\n  width: 60px;\n  height: 60px;\n  text-align: center;\n  padding: 8px;\n  border-radius: 6px;\n}\n\n.attribute-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.attribute-list li {\n  margin-bottom: 10px;\n  border-radius: 6px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.attribute-list .row-label {\n  margin-bottom: 5px;\n  min-width: inherit;\n}\n\n.attribute-list .row-value {\n  font-weight: 700;\n  font-size: 12px;\n  margin-left: auto;\n}\n\n.trackers-list {\n  list-style: none;\n  margin: 0 0 0 -16px;\n  padding: 0;\n  text-align: center;\n}\n\n.trackers-list li {\n  box-sizing: border-box;\n  border-radius: 6px;\n  width: calc(25% - 16px);\n  float: left;\n  margin-left: 16px;\n  margin-bottom: 16px;\n  padding: 0;\n}\n\n.trackers-list .row-label {\n  font-size: 12px;\n  font-weight: normal;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: inherit;\n}\n\n.trackers-list .row-value {\n  font-size: 12px;\n}\n\n.row-image {\n  width: 80px;\n  height: 80px;\n}\n\n.license-card-detail p {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 10px 0;\n}\n\n.license-card-detail .row-label {\n  margin-bottom: 5px;\n}\n\n.license-card-detail .row-value {\n  text-align: right;\n  margin-left: auto;\n}\n\n.license-card-detail {\n  font-size: 12px;\n  padding: 0 0 10px;\n  margin-bottom: 30px;\n}\n\n.MuiSkeleton-pulse {\n  animation: MuiSkeleton-keyframes-pulse 1.5s ease-in-out 0.5s infinite;\n}\n\n@-webkit-keyframes MuiSkeleton-keyframes-pulse {\n  0% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.4;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.skeleton-wave {\n  overflow: hidden;\n  position: relative;\n}\n\n.skeleton-wave::after {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  content: '';\n  z-index: 1;\n  position: absolute;\n  animation: MuiSkeleton-keyframes-wave 2.6s linear 0.5s infinite;\n  transform: translateX(-100%);\n  background: linear-gradient(90deg,\n      transparent,\n      rgba(0, 0, 0, 0.04),\n      transparent);\n}\n\n.geofence-modal {\n  /*   &.hide-delete-btn {\n    .leaflet-draw-edit-remove {\n      display: none;\n    }\n  }\n */\n  display: flex;\n\n  &-form {\n    position: relative;\n    width: 275px;\n    z-index: 9999;\n    font-size: 12px;\n    overflow: hidden;\n\n    &-inner {\n      height: 310px;\n      overflow-y: scroll;\n      display: flex;\n      flex: 1;\n      flex-direction: column;\n      right: -1px;\n      position: relative;\n\n      >div {\n        padding: 0 12px;\n\n        &:nth-child(even) {\n          background: rgba($color: #fff, $alpha: 0.15);\n        }\n      }\n    }\n\n    .ScrollbarsCustom-Wrapper {\n      right: 0 !important;\n    }\n\n    .ScrollbarsCustom-Content {\n      padding: 12px !important;\n    }\n\n    &-footer {\n      width: 100%;\n      text-align: right;\n      border-top: 1px solid rgba(#fff, 0.15);\n      padding: 10px;\n    }\n  }\n\n  .dialog-full-screen & &-form {\n    .geofence-modal-form-inner {\n      height: calc(100% - 50px);\n    }\n  }\n\n  &-map {\n    flex: 1;\n  }\n\n  .dialog-full-screen & {\n    height: calc(100vh - 44px);\n  }\n}\n\n.notification-wizard {\n  margin: 0;\n  padding: 0;\n\n  .theme-button {\n    border-radius: 0;\n    padding: 8px 15px;\n    font-size: 15px;\n    text-transform: none;\n\n    svg {\n      display: block;\n    }\n\n    .row-related-icon {\n      margin-left: auto;\n      transform: rotate(-90deg);\n    }\n\n    &.active {\n      .row-related-icon {\n        transform: rotate(0);\n      }\n    }\n  }\n\n  li {\n    margin-top: 6px;\n  }\n}\n\n.notification-wizard-inner {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n\n  .theme-button {\n    font-size: 13px;\n    border-radius: 0;\n    padding: 8px 15px 8px 35px;\n  }\n\n  .custom-indicator {\n    background: #fff !important;\n  }\n}\n\n\n.maintenance-page .fms-sidebar .list-view {\n  padding: 0;\n}\n\n.unread {\n  cursor: pointer;\n}\n\n.unread .read-unread-mark {\n  width: 10px;\n  height: 10px;\n  border-radius: 10px;\n  float: right;\n}\n\n.maintain-height {\n  margin-top: 28px;\n}\n\n.notification-head-row {\n  padding: 5px 10px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n}\n\n\n@keyframes MuiSkeleton-keyframes-wave {\n  0% {\n    transform: translateX(-100%);\n  }\n\n  60% {\n    transform: translateX(100%);\n  }\n\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n.skeleton-pulse {\n  animation: MuiSkeleton-keyframes-pulse 1.5s ease-in-out 0.5s infinite;\n}\n\n@keyframes MuiSkeleton-keyframes-pulse {\n  0% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.4;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.alert {\n  padding: 6px 9px;\n  border: 1px solid;\n  border-radius: 4px;\n  margin: 20px auto;\n  font-size: $baseFontSize;\n\n  svg {\n    vertical-align: middle;\n    margin-right: 6px;\n  }\n}\n\n.graph-total-unit {\n  font-size: 1.5em;\n  font-weight: bold;\n}\n\n.notification-model-common-section {\n  padding-left: 10px;\n\n  &.opened {\n    height: 100%;\n  }\n}\n\n.highcharts-data-label {\n  .pie-tooltip {\n    display: flex;\n\n    &-image {\n      width: 26px;\n      align-items: center;\n      justify-content: center;\n      display: flex;\n      border-radius: 4px;\n      padding: 5px;\n    }\n\n    &-label {\n      padding-left: 10px;\n      font-family: $baseFontFamily;\n      align-items: center;\n      display: flex;\n\n      b {\n        font-size: 1.8em;\n        font-weight: 900;\n        padding-right: 7px;\n      }\n    }\n  }\n\n  .pie-tooltip-half-1 {\n    .pie-tooltip-image {\n      order: 1;\n    }\n\n    .pie-tooltip-label {\n      order: 0;\n      padding-left: 0;\n      padding-right: 10px;\n      text-align: right;\n    }\n  }\n}\n\n.highcharts-text-outline {\n  display: none;\n}\n\n.scroll-auto {\n  overflow: auto !important;\n}\n\n.scroll-visible {\n  overflow: visible !important;\n}\n\n.motion-status-bar {\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n\n  .motion-status-img {\n    margin-right: 10px;\n  }\n\n  .motion-status-name {\n    min-width: 0;\n    margin-right: 10px;\n    font-size: 12px;\n    font-weight: bold;\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  img {\n    width: 20px;\n    height: 20px;\n  }\n\n  .motion-status-border {\n    width: 18px;\n    border-radius: 9px;\n    height: 18px;\n    margin-right: 10px;\n  }\n\n  .motion-status-count {\n    font-weight: bold;\n    margin-left: auto;\n    font-size: 18px;\n    font-weight: 700;\n    padding-right: 4px;\n    font-style: italic;\n  }\n  .motion-status-currency {\n    font-weight: bold;\n    margin-left: auto;\n    font-weight: normal;\n    font-size: 12px;\n    padding-right: 4px;\n    font-style: italic;\n  }\n\n  &.multi-columns {\n    margin-top: 5px;\n    width: calc(50% - 2.5px);\n\n    .motion-status-border {\n      margin-right: 8px;\n    }\n\n    .motion-status-img {\n      margin-right: 8px;\n\n      img {\n        width: 26px;\n        height: 26px;\n      }\n    }\n  }\n}\n\n.multi-columns-wrap {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.driver-state-wrap {\n  >h3 {\n    font-size: 2em;\n    margin-bottom: 0;\n  }\n\n  >p {\n    font-size: 1.3em;\n    margin: 0 0 16px;\n  }\n\n  .driver-state-container {\n    display: flex;\n    flex: 1;\n    flex-wrap: wrap;\n    margin-left: -12px;\n  }\n  .maintenace-state-container {\n    gap: 3px;\n    margin: 0;\n  }\n\n  .driver-state,\n  .driver-state2 {\n    width: calc(50% - 12px);\n    margin-left: 12px;\n    margin-bottom: 12px;\n    padding: 17px 15px 10px;\n    border-radius: 6px;\n    text-align: center;\n    color: #fff;\n\n    h3 {\n      font-size: 18px;\n      margin-bottom: 5px;\n      margin-top: 10px;\n    }\n\n    p {\n      margin-top: 5px;\n    }\n\n    &.online {\n      background: #28a745;\n    }\n\n    &.offline {\n      background: #dc3545;\n    }\n\n    &.not-register {\n      background: #566374;\n    }\n\n    &.not-update {\n      background: #1976d2;\n    }\n  }\n\n  .driver-state-inline {\n    min-width: 80px;\n    flex: 1;\n    margin-left: 0;\n    padding: 18px 3px;\n    border-radius: 0;\n    h3 {\n      margin-bottom: 0;\n      margin-top: 5px;\n      font-size: 21px;\n    }\n\n    p {\n      font-size: 14px;\n      margin-top: 0;\n    }\n  }\n  /* .driver-state {\n    width: calc(50% - 24px);\n    margin-left: 16px;\n    margin-bottom: 12px;\n    padding: 10px;\n    border-radius: 6px;\n    img {\n      margin-top: 3px;\n      float: left;\n    }\n    h3 {\n      font-size: 20px;\n      margin: 0;\n      margin-left: 45px;\n    }\n    p {\n      margin-top: 0;\n      margin-bottom: 0;\n      margin-left: 45px;\n    }\n  } */\n}\n\n.button-to-normal {\n  cursor: pointer;\n  background: none;\n  border: 0;\n  color: inherit;\n  font-size: 18px;\n  padding: 0 0 0 10px;\n  vertical-align: middle;\n}\n\n.MuiDialog-paper {\n  overflow-y: visible !important;\n}\n\n.theme-range-slider {\n  height: 8px !important;\n}\n\n.theme-range-slider .theme-range-slider-thumb {\n  height: 24px;\n  width: 24px;\n  background-color: #fff;\n  border: 2px solid currentColor;\n  margin-top: -8px;\n  margin-left: -12px;\n}\n\n.theme-range-slider .theme-range-slider-label {\n  left: calc(-50% + 4px);\n  top: -22px;\n  /* span {\n    color: inherit;\n  } */\n}\n\n/* .theme-range-slider .theme-range-slider-label * {\n  background: transparent;\n} */\n.theme-range-slider .theme-range-slider-rail,\n.theme-range-slider .theme-range-slider-track {\n  height: 8px;\n  border-radius: 4px;\n}\n\n.fake-calendar {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border-top: 1px solid rgba(#000, 0.15);\n  border-left: 1px solid rgba(#000, 0.15);\n\n  li {\n    float: left;\n    width: 20%;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-right: 1px solid rgba(#000, 0.15);\n    border-bottom: 1px solid rgba(#000, 0.15);\n  }\n\n  label {\n    cursor: pointer;\n    display: inline-block;\n    width: 2em;\n    height: 2em;\n    text-align: center;\n    line-height: 2;\n    border-radius: 40px;\n  }\n\n  .selected-day label {\n    background: rgba(#000000, 0.25);\n  }\n\n  .highlight label {\n    background: rgba(#000000, 0.5);\n  }\n}\n\n.fake-calendar-result {\n  float: right;\n  margin-bottom: 10px;\n}\n\n.rta__autocomplete {\n  color: #333;\n  z-index: 99;\n}\n\n.rta__list {\n  max-height: 150px;\n  border: 0;\n  overflow: auto;\n}\n\n.rta__entity {\n  padding: 6px 12px;\n  font-size: 0.8em;\n}\n\n.menu_item_text_inner {\n  text-align: left;\n}\n\n::-webkit-input-placeholder {\n  /* Chrome/Opera/Safari */\n  color: rgba(#fff, 0.5);\n}\n\n::-moz-placeholder {\n  /* Firefox 19+ */\n  color: rgba(#fff, 0.5);\n}\n\n:-ms-input-placeholder {\n  /* IE 10+ */\n  color: rgba(#fff, 0.5);\n}\n\n:-moz-placeholder {\n  /* Firefox 18- */\n  color: rgba(#fff, 0.5);\n}\n\n.react-time-picker__clear-button {\n  display: none;\n}\n\n.react-time-picker__wrapper {\n  padding: 2px 10px 3px;\n  border-radius: 4px;\n}\n\n.react-time-picker__inputGroup__input {\n  outline: 0;\n}\n\n.custom-unit-tabpanel-container {\n  padding-bottom: 20px;\n}\n\n.messages-table {\n  font-size: 12px;\n}\n\n\n.theme-builder-module {\n  padding: 20px;\n\n  h1 {\n    margin: 0 0 10px;\n  }\n\n}\n\n// .dnd-ebuilder-wrapper {\n//   padding: 16px;\n//   box-shadow: 0px 2px 1px -1px rgba(#000, 0.2), 0px 1px 1px 0px rgba(#000, 0.14), 0px 1px 3px 0px rgba(#000, 0.12);\n// }\n\n.dnd-ebuilder {\n  padding: 15px;\n  border-radius: 6px;\n\n  h3 {\n    margin-top: 4px;\n    margin-bottom: 0;\n  }\n\n  h4 {\n    margin-top: 5px;\n    margin-bottom: 5px;\n  }\n\n  .dnd-drop {\n    border: 1px dashed;\n    border-radius: 6px;\n    padding: 15px;\n    border-radius: 6px;\n    min-height: 100px;\n  }\n\n  .dnd-dropable {\n    background: rgba(0, 0, 0, 0.15);\n  }\n\n  .tag {\n    border-radius: 4px;\n    padding: 6px 12px;\n    margin-right: 8px;\n    display: inline-block;\n    vertical-align: middle;\n  }\n\n  .dropable-placehoder {\n    border: 1px dashed;\n    padding: 4px 12px;\n    height: 2em;\n    min-width: 120px;\n    display: inline-block;\n    vertical-align: middle;\n  }\n\n  .dnd-placeholder {\n    margin-bottom: 0;\n    position: relative;\n\n    p {\n      font-weight: bold;\n      margin-top: 5px;\n      margin-bottom: 5px;\n    }\n  }\n\n  .dnd-box {\n    margin-right: 0.5rem;\n    padding: 0.25rem 0.75rem;\n    margin-bottom: 0.5rem;\n    border-radius: 3px;\n    cursor: move;\n    display: inline-block\n  }\n\n  .text-right .dnd-box {\n    margin-right: 0;\n    margin-left: 1rem;\n  }\n\n  .dnd-empty {\n    text-align: center;\n\n    h2 {\n      font-size: 1em;\n      margin-top: 0;\n    }\n\n    svg {\n      width: 40px;\n    }\n  }\n\n  .action-rollback-btn {\n    position: absolute;\n    top: 9px;\n    right: 1px;\n  }\n\n}\n\n.feature-close-button {\n  position: absolute;\n  margin-top: 6px;\n  // color: #747474;\n  right: 15px;\n  top: 3px;\n  font-size: 24px !important;\n  cursor: pointer;\n  // &:hover {\n  //   color: #000;\n  // }\n}\n\n.driver-modal-fixed,\n.feature-row-1,\n.feature-row {\n  position: fixed;\n  bottom: $footerHeight;\n  top: $topGap;\n  left: $sidebarWidth + $filterColWidth;\n  width: $sidebarWidth;\n  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n  border-radius: 0;\n}\n\n.feature-row-1,\n.driver-modal-fixed {\n  left: $sidebarWidth;\n}\n\n.feature-row-head {\n  padding: 6px 19px;\n  font-weight: 500;\n  font-family: $altFontFamily;\n  font-size: 24px;\n  line-height: 36px;\n\n  img {\n    vertical-align: top;\n    margin-right: 15px;\n  }\n\n  .feature-row-head-name {\n    display: inline-block;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    vertical-align: top;\n\n    &.status {\n      font-size: $baseFontSize;\n      font-style: italic;\n      font-weight: normal;\n      display: flex;\n      align-items: center;\n      font-family: $baseFontFamily;\n      gap: 5px;\n    }\n  }\n}\n\n.feature-row-inner {\n  height: calc(100vh - #{$headerHeight} - #{$footerHeight} - 97px);\n}\n\n.feature-section {\n  display: block;\n  vertical-align: top;\n  font-size: $baseFontSize - 1px;\n  line-height: 1.4;\n  position: relative;\n  transition: all 0.3s ease;\n\n  .item-row {\n    font-size: 12px;\n    line-height: 24px;\n    //color: #888;\n    font-weight: 300;\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    margin-bottom: 8px;\n\n    svg {\n      width: 18px;\n      height: 18px;\n    }\n\n    .row-label {\n      display: block;\n      // font-weight: 700;\n      min-width: inherit;\n      margin: 0;\n      line-height: 1.1;\n      min-width: 100px;\n    }\n\n    .row-value {\n      font-size: $baseFontSize;\n      margin: 0;\n      line-height: 1.1;\n    }\n  }\n\n  h3 {\n    padding: 7px 0 0;\n    //font-style: italic;\n    font-size: $baseFontSize + 6px;\n    margin: 0 10px;\n    font-weight: 500;\n    //color: #5f5f5f;\n    //background: #f7f7f7;\n  }\n\n  /* &:hover {\n\t\t//z-index: 1;\n\t\t//transform: scale(1.02);\n\t\t.feature-section-close {\n\t\t\tdisplay: block;\n\t\t}\n\t} */\n  .list-unstyled {\n    margin: 0;\n    padding: 0;\n  }\n}\n\n\n.fms-notification-inner {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n\n}\n\n\n.collapseable {\n  margin-bottom: 4px;\n  min-height: 50px;\n\n  .feature-row-head {\n    font-family: $altFontFamily;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n\n/****** Chat Popup Layout ******/\n.msg_head,\n.boxhandle-icon {\n  cursor: move;\n}\n\n.msg_box {\n  position: fixed;\n  bottom: 30px;\n  overflow: hidden;\n  z-index: 9999999;\n  border: 1px solid rgba($color: #000000, $alpha: 0.5);\n  background: #fff;\n}\n\n.msg_head {\n  align-items: center;\n  font-weight: bold;\n  font-size: 12px;\n  display: flex;\n\n  >div {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .msg-unit-icon {\n    width: 30px;\n    height: 30px;\n  }\n}\n\n.closebox {\n  cursor: pointer;\n  padding: 3px;\n\n  &:hover {\n    background: rgba(#000, 0.15);\n  }\n\n  svg {\n    fill: currentColor;\n    width: 24px;\n    height: 24px;\n    display: block;\n  }\n}\n\n.boxhandle-icon {\n  height: 10px;\n}\n\n.react-contextmenu.react-contextmenu--visible {\n  min-width: 220px;\n  background: #fff;\n  border: solid 1px #DADCE0;\n  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.04);\n}\n\n.react-contextmenu {\n  .react-contextmenu-item {\n    cursor: pointer;\n    display: block;\n    padding: 5px 40px;\n    font-size: 11px;\n    font-weight: normal;\n    color: #202124;\n  }\n\n  .react-contextmenu-item--selected {\n    background: #C8C8C9;\n  }\n}\n\n.modal-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.sensors-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 172px;\n  margin-left: 20px;\n\n  .theme-button {\n    width: 100%;\n    box-shadow: none;\n    border-top: 5px solid transparent;\n    border-radius: 0;\n  }\n}\n\n\n//.ScrollbarsCustom-Scroller{padding-right: 0 !important; margin: 0 !important;}\n@media (max-width: 959px) {\n\n  .show-tracks,\n  .show-points {\n    display: none;\n  }\n\n  .leaflet-top.leaflet-right {\n    top: 0;\n  }\n\n}\n\n@media (max-width: 767px) {\n  .main-content-page {\n    margin-top: 0;\n    margin-left: 8px;\n  }\n  .v-filter-field2 {\n    flex-wrap: wrap;\n    row-gap: 0;\n  }\n  .v-filter-field2 > div { min-width: 90px;}\n  .sidebar-icon-gap {\n    padding-left: 0 !important;\n  }\n  \n  .license-card-img {\n    float: none;\n    width: auto;\n  }\n\n  .license-card-detail {\n    margin-left: 0;\n  }\n\n  .sidebar-collapse-button {\n    top: 0;\n    margin-top: 3px;\n  }\n  .logo-section {\n    margin-left: 42px;\n  }\n}\n\n@media (max-width: 479px) {\n  .trackers-list li {\n    width: calc(100% - 16px);\n  }\n}\n\n// @media (min-width: 960px) {\n//   .main-unit-modal-bg .custom-unit-tabpanel-container {\n//     float: right;\n//     width: calc(100% - 220px);\n//   }\n// }\n\n@media (max-width: 959px) {\n  .driver-page-content {\n    border-radius: 6px;\n  }\n}\n\n.react-base-table {\n  table-layout: fixed;\n  border-collapse: collapse;\n  .MuiSvgIcon-root {\n    display: block;\n  }\n  .MuiTableCell-sizeSmall:last-child,\n  .MuiTableCell-sizeSmall {\n    padding: 6px;\n  }\n\n  a,\n  .MuiTableCell-root {\n    color: inherit;\n    position: relative;\n    border-bottom: 0;\n  }\n\n  .MuiTableCell-head {\n    font-weight: bold;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .MuiTableCell-body {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &.custom-table {\n    .MuiTableCell-body {\n      overflow: visible;\n      white-space: nowrap;\n      a {\n        display: inline-block;\n      }\n    }\n  }\n\n  .MuiTableCell-head {\n    white-space: normal;\n  }\n\n  .MuiTableCell-body a {\n    display: block;\n    overflow: inherit;\n    text-overflow: inherit;\n    white-space: inherit;\n  }\n}\n\n.react-base-table-wrapper {\n  .resizer {\n    display: block;\n    width: 10px;\n    height: 100%;\n    position: absolute;\n    right: 0;\n    top: 0;\n    z-index: 1;\n    touch-action: none;\n\n    &.isResizing {\n      background: rgba(#000000, 0.05);\n    }\n  }\n\n  .MuiPaginationItem-root,\n  .MuiTablePagination-root,\n  .MuiPaginationItem-root {\n    color: inherit;\n  }\n\n  .MuiTablePagination-actions .MuiIconButton-root {\n    padding: 3px;\n  }\n\n  .MuiTablePagination-toolbar {\n    min-height: 40px;\n  }\n\n  .MuiPaginationItem-root {\n    height: 27px;\n    min-width: 27px;\n  }\n}\n\n\n.btn-link {\n  font-size: 0.8em;\n  padding: 0 4px;\n  color: currentColor;\n  padding: 5px 10px;\n  background: rgba(white, 0.25);\n  margin-right: 6px;\n  border-radius: 4px;\n\n  &.active {\n    font-weight: bold;\n  }\n}\n\n.search-field {\n  position: absolute;\n  right: 10px;\n  top: 54px;\n  z-index: 9999;\n  background-clip: padding-box;\n  background-color: #fff;\n  border-radius: 4px;\n  \n  [class*=\"control\"] {\n    border: 1px solid #1E72B84D;\n    background-color: #1E72B81A;\n    min-height: 36px;\n  }\n}\n\n.navbar-indicator {\n  background-color: transparent\n}\n\n.navbar-selected {\n  background-color: rgba(0, 0, 0, 0.1);\n  font-weight: bold\n}\n\n.stat-block {\n  min-width: 120px;\n  margin-bottom: 12px;\n  padding: 17px 15px;\n  border-radius: 6px;\n  text-align: center;\n  margin-right: 12px;\n\n  p {\n    margin-bottom: 0;\n    margin-top: 0;\n    font-size: 30px;\n    font-weight: bold;\n  }\n\n  span {\n    margin-top: 0;\n    font-size: 11px\n  }\n}\n\n.loading-dot {\n  font-size: 4px;\n  animation: selectLoader 1s ease-in-out 0ms infinite;\n  background-color: currentColor;\n  border-radius: 1em;\n  display: inline-block;\n  height: 1em;\n  vertical-align: middle;\n  width: 1em;\n\n  &~& {\n    margin-left: 1em;\n  }\n}\n\n@keyframes selectLoader {\n\n  0%,\n  80%,\n  100% {\n    opacity: 0;\n  }\n\n  40% {\n    opacity: 1;\n  }\n}\n\n.loading-status-text {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 10px;\n\n  .status-icon {\n    margin-right: 5px;\n  }\n}\n\n.process-list {\n  padding: 0;\n  list-style: none;\n  display: flex;\n  justify-content: space-between;\n\n  li {\n    display: inline-flex;\n    align-items: center;\n  }\n}\n\n.custom-badge {\n  padding: 2px 8px 4px;\n  border-radius: 14px;\n  background: #d32f2f;\n  color: #fff;\n  line-height: 1;\n  font-weight: bold;\n  &.on {\n    background: #28A745;\n  }\n}\n.custom-tabs-root,\n.custom-tabs { \n  .MuiTabScrollButton-root.Mui-disabled {\n    display: none;\n  }\n}\n\n.custom-mileage-list {\n  padding: 5px 12px;\n  border-radius: 6px;\n  margin-top: 7px;\n  span {\n    display: block;\n    text-align: center;\n    padding: 5px 0;\n    ~ span {\n      border-top-width: 1px;\n      border-top-style: dashed;\n    }\n  }\n}\n.MuiLinearProgress-root.MuiLinearProgress-determinate {\n  background: #E9EAEB;\n  border-radius: 4px;\n  margin-top: 4px;\n  .MuiLinearProgress-bar {\n    border-radius: 4px;\n  }\n}\n.light-blue .MuiLinearProgress-bar {\n  background-color: #4DCEF0;\n}\n.purple .MuiLinearProgress-bar {\n  background-color: #B31EFC;\n}\n.success .MuiLinearProgress-bar {\n  background-color: #28A745;\n}\n.danger .MuiLinearProgress-bar {\n  background-color: #DC3545;\n}\n.primary .MuiLinearProgress-bar {\n  background-color: #0288D1;\n}\n.warning .MuiLinearProgress-bar {\n  background-color: #E6B535;\n}\n.MuiTableCell-root {\n  &.text-success {\n    font-weight: bold;\n    color: #28A745;\n  }\n  &.text-danger {\n    font-weight: bold;\n    color: #DC3545;\n  }\n  &.text-primary {\n    font-weight: bold;\n    color: #0288D1;\n  }\n  &.text-warning {\n    font-weight: bold;\n    color: #E6B535;\n  }\n}\n.md-table {\n  .MuiTableCell-root {\n    font-size: 16px;\n  }\n  .MuiTableCell-head {\n    font-size: 18px;\n    font-weight: bold;\n  }\n  .row-label {\n    font-size: inherit;\n  }\n}\n\n.black-warning.MuiLinearProgress-root {\n  background-color: #fff;\n}\n.black-warning .MuiLinearProgress-bar {\n  background-color: #000;\n  &:after {\n    content: \"\";\n    display: block;\n    height: 100%;\n    width: 100%;\n    left: 100%;\n    margin-left: 12px;\n    position: absolute;\n    border-radius: 4px;\n    background-color: #E6B535;\n  }\n}\n\n.section-title {\n  font-size: 18px;\n  margin-bottom: 7px;\n  gap: 10px;\n  display: flex;\n}\n\n.md-bar-graphlist {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  li {\n    padding: 5px 0;\n  }\n  .row-label {\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    gap: 7px;\n  }\n  .row-value {\n    font-size: 16px;\n  }\n  .row-label-sm {\n    font-size: 12px;\n    margin-top: 5px;\n  }\n}\n.md-category-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n  border-bottom: 2px dashed #70707033;\n  li {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px 0;\n    ~ li {\n      border-top: 1px solid #E9EAEB;\n    }\n  }\n  .row-label {\n    font-size: 14px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 7px;\n  }\n  .row-value {\n    font-size: 16px;\n    font-weight: 700;\n  }\n}\n\n.md-col-first {\n  padding: 12px;\n  height: calc(100vh - #{$headerHeight} - #{$footerHeight});\n  // border-right: 2px dashed #70707033;\n}\n.md-col-second {\n  padding: 12px; \n  // border-right: 2px dashed #70707033;\n  // border-bottom: 2px dashed #70707033;\n}\n\n.motion-status-bar-inline {\n  padding-bottom: 0;\n  flex-direction: column; \n  width: 70px;\n  border-bottom: 0 !important;\n  text-align: center;\n  padding: 0 5px;\n  > * {\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n  .motion-status-border {\n    width: 38px;\n    height: 6px;\n  }\n  img {\n    width: 42px;\n    height: 42px;\n  }\n  .motion-status-name,\n  .motion-status-count {\n    text-align: center;\n    margin: auto;\n    order: -1;\n    font-style: normal;\n  }\n  .motion-status-name {\n    min-width: 0;\n    width: 100%;\n    margin: 5px auto;\n  }\n  .motion-status-count {\n    font-size: 16px;\n    margin-bottom: 10px;\n  }\n}\n\n.trackYVisible .ScrollbarsCustom-TrackY {max-width: 4px;}\n\n.ScrollbarsCustom-Wrapper {\n  inset: 0 !important;\n}\n\n.MuiList-padding.MuiMenu-list {\n  padding: 0 ;\n}","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$filterColWidth: 72px;\n$sidebarWidth : 306px;\n$sidebarMaintenanceWidth: $sidebarWidth + 131px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 44px;\n$headerNavWidth: 150px;\n$headerHeight: 48px;\n$footerHeight: 24px;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 1;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: transparent;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #ffffff;\n$lightGrey: #b7b7b7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 99999;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 12px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Inter, sans-serif;\n$altFontFamily: 'Bebas Neue', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
